/**
 * A function to create a log object for the 'notInUse' event (evid: 1)
 *
 * Event description: Not in use.
 *
 * @param {notInUseParams} params - The parameters for this event
 * @property {number} uouIndexInClient - uou_index_in_client
 * @property {GUID} hypeUserId - hype_user_id
 * @property {string} screenPart - screen_part
 * @property {string} hoppUserProfiles - hopp_user_profiles
 * @property {GUID} uouClientId - uou_client_id
 * @property {number} windowHeight - window_height
 * @property {string} panelName - panel_name
 * @property {number} uouIndexInSession - uou_index_in_session
 * @property {string} origin - origin
 * @property {GUID} uouSessionId - uou_session_id
 * @property {number} screenWidth - screen_width
 * @property {string} environment - environment
 * @property {string} dialogName - dialog_name
 * @property {number} screenHeight - screen_height
 * @property {string} uouReferrer - uou_referrer
 * @property {string} pageName - page_name
 * @property {string} type - type
 * @property {number} windowWidth - window_width
 * @return {LogObject<notInUseParams>} LogObject<notInUseParams>
 */
export function notInUse(params) {
    return { evid: 1, src: 146, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uouContactSubscribed' event (evid: 1000)
 *
 * Event description: When uou subscribed
 *
 * @param {uouContactSubscribedParams} params - The parameters for this event
 * @property {GUID} hypeUserId - hype_user_id
 * @property {string} linkId - link id
 * @property {string} actionId - action_id
 * @property {string} pageId - page id
 * @property {string} destinationUrl - destination url
 * @property {string} uouReferrer - uou_referrer
 * @property {string} subscriptionType - (phone/email)
 * @return {LogObject<uouContactSubscribedParams>} LogObject<uouContactSubscribedParams>
 */
export function uouContactSubscribed(params) {
    return { evid: 1000, src: 146, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uouDestinationRedirected' event (evid: 1001)
 *
 * Event description: When uou was redirected to destination
 *
 * @param {uouDestinationRedirectedParams} params - The parameters for this event
 * @property {GUID} hypeUserId - hype_user_id
 * @property {string} linkId - link id
 * @property {string} pageId - page id
 * @property {string} destinationUrl - destination url
 * @property {string} uouReferrer - uou_referrer
 * @property {boolean} passthrough - passthrough
 * @return {LogObject<uouDestinationRedirectedParams>} LogObject<uouDestinationRedirectedParams>
 */
export function uouDestinationRedirected(params) {
    return { evid: 1001, src: 146, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uAccountActivated' event (evid: 1002)
 *
 * Event description: When user logs in or signs up to Hype for the first time and gets a Hype user id
 *
 * @param {uAccountActivatedParams} params - The parameters for this event
 * @property {GUID} hypeUserId - hype user id
 * @property {boolean} hasWixUser - true\false
 * @property {boolean} isFirstTime - true\false
 * @property {string} uouReferrer - uou_referrer
 * @return {LogObject<uAccountActivatedParams>} LogObject<uAccountActivatedParams>
 */
export function uAccountActivated(params) {
    return { evid: 1002, src: 146, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uouPageRequest' event (evid: 1003)
 *
 * Event description: uou Page Request
 *
 * @param {uouPageRequestParams} params - The parameters for this event
 * @property {GUID} hypeUserId - hype user id
 * @property {string} linkId - link id
 * @property {string} pageId - page id
 * @property {string} destinationUrl - destination url
 * @property {string} uouReferrer - uou_referrer
 * @return {LogObject<uouPageRequestParams>} LogObject<uouPageRequestParams>
 */
export function uouPageRequest(params) {
    return { evid: 1003, src: 146, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uPageCreated' event (evid: 1004)
 *
 * Event description: When hype user created new page
 *
 * @param {uPageCreatedParams} params - The parameters for this event
 * @property {GUID} hypeUserId - hype user id
 * @property {string} pageId - the page id created
 * @property {string} uouReferrer - uou_referrer
 * @return {LogObject<uPageCreatedParams>} LogObject<uPageCreatedParams>
 */
export function uPageCreated(params) {
    return { evid: 1004, src: 146, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uouServerPaymentConfirmation' event (evid: 1005)
 *
 * Event description: When uou payment completed
 *
 * @param {uouServerPaymentConfirmationParams} params - The parameters for this event
 * @property {GUID} hypeUserId - hype_user_id
 * @property {string} linkId - link id
 * @property {string} actionId - action_id
 * @property {string} pageId - page id
 * @property {string} destinationUrl - destination url
 * @property {string} uouReferrer - uou_referrer
 * @property {string} value - price
 * @property {string} currency - currency
 * @property {string} pageType - page type
 * @property {string} paymentIntentId - paymentIntentId
 * @return {LogObject<uouServerPaymentConfirmationParams>} LogObject<uouServerPaymentConfirmationParams>
 */
export function uouServerPaymentConfirmation(params) {
    return { evid: 1005, src: 146, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uDropdownValueChosen' event (evid: 11)
 *
 * Event description: When user clicks on a dropdown value
 *
 * @param {uDropdownValueChosenParams} params - The parameters for this event
 * @property {number} uouIndexInClient - uou_index_in_client
 * @property {GUID} hypeUserId - the unique id of a hype user
 * @property {string} screenPart - screen_part
 * @property {string} hoppUserProfiles - hopp_user_profiles
 * @property {GUID} uouClientId - uou_client_id
 * @property {number} windowHeight - window_height
 * @property {string} panelName - panel_name
 * @property {number} uouIndexInSession - uou_index_in_session
 * @property {string} origin - current screen/tab/specific description of location
 * @property {GUID} uouSessionId - uou_session_id
 * @property {number} screenWidth - screen_width
 * @property {string} environment - environment
 * @property {string} dropdownName - the name of the dropdown
 * @property {string} dialogName - dialog_name
 * @property {number} screenHeight - screen_height
 * @property {string} uouReferrer - uou_referrer
 * @property {string} pageName - page_name
 * @property {string} type - type
 * @property {number} windowWidth - window_width
 * @property {string} value - the value
 * @return {LogObject<uDropdownValueChosenParams>} LogObject<uDropdownValueChosenParams>
 */
export function uDropdownValueChosen(params) {
    return { evid: 11, src: 146, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickOnCta' event (evid: 1201)
 *
 * Event description: Anon/User click on a CTA on Hype Landing Page
 *
 * @param {clickOnCtaParams} params - The parameters for this event
 * @property {GUID} visitorId - visitor id
 * @property {string} targetUrl - target url of the cta clicked
 * @property {string} section - section where the cta is located (first_fold, footer, second_fold etc.)
 * @property {string} ctaName - nome of the cta
 * @return {LogObject<clickOnCtaParams>} LogObject<clickOnCtaParams>
 */
export function clickOnCta(params) {
    return { evid: 1201, src: 146, endpoint: '', params };
}
/**
 * A function to create a log object for the 'hoppLpIsLoaded' event (evid: 1202)
 *
 * Event description: when the new editorX LP is loaded
 *
 * @param {hoppLpIsLoadedParams} params - The parameters for this event
 * @property {string} utmData - utm params
 * @return {LogObject<hoppLpIsLoadedParams>} LogObject<hoppLpIsLoadedParams>
 */
export function hoppLpIsLoaded(params) {
    return { evid: 1202, src: 146, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uTabSwitched' event (evid: 13)
 *
 * Event description: When user moves from one tab to another
 *
 * @param {uTabSwitchedParams} params - The parameters for this event
 * @property {number} uouIndexInClient - uou_index_in_client
 * @property {GUID} hypeUserId - the unique id of a hype user
 * @property {string} screenPart - screen_part
 * @property {string} hoppUserProfiles - hopp_user_profiles
 * @property {GUID} uouClientId - uou_client_id
 * @property {number} windowHeight - window_height
 * @property {string} panelName - panel_name
 * @property {number} uouIndexInSession - uou_index_in_session
 * @property {string} origin - current screen/tab/specific description of location
 * @property {GUID} uouSessionId - uou_session_id
 * @property {number} screenWidth - screen_width
 * @property {string} environment - environment
 * @property {string} dialogName - dialog_name
 * @property {number} screenHeight - screen_height
 * @property {string} uouReferrer - uou_referrer
 * @property {string} targetTabName - the name of the chosen tab
 * @property {string} pageName - page_name
 * @property {string} type - type
 * @property {number} windowWidth - window_width
 * @property {string} currentTabName - the name of the previous tab before click
 * @property {string} tabsName - editor/settings etc...
 * @return {LogObject<uTabSwitchedParams>} LogObject<uTabSwitchedParams>
 */
export function uTabSwitched(params) {
    return { evid: 13, src: 146, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uValueSearched' event (evid: 15)
 *
 * Event description: When user uses the search input field (trigerred when he stops typing)
 *
 * @param {uValueSearchedParams} params - The parameters for this event
 * @property {number} uouIndexInClient - uou_index_in_client
 * @property {GUID} hypeUserId - the unique id of a hype user
 * @property {string} screenPart - screen_part
 * @property {string} resourceType - (contacts/links)
 * @property {string} hoppUserProfiles - hopp_user_profiles
 * @property {GUID} uouClientId - uou_client_id
 * @property {number} windowHeight - window_height
 * @property {string} panelName - panel_name
 * @property {number} uouIndexInSession - uou_index_in_session
 * @property {string} origin - current screen/tab/specific description of location
 * @property {GUID} uouSessionId - uou_session_id
 * @property {number} screenWidth - screen_width
 * @property {string} environment - environment
 * @property {string} dialogName - dialog_name
 * @property {number} screenHeight - screen_height
 * @property {string} uouReferrer - uou_referrer
 * @property {string} pageName - page_name
 * @property {string} type - type
 * @property {number} windowWidth - window_width
 * @property {string} value - the value
 * @return {LogObject<uValueSearchedParams>} LogObject<uValueSearchedParams>
 */
export function uValueSearched(params) {
    return { evid: 15, src: 146, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uSwitchPreviewClicked' event (evid: 16)
 *
 * Event description: When user switches between mobile and web preview
 *
 * @param {uSwitchPreviewClickedParams} params - The parameters for this event
 * @property {number} uouIndexInClient - uou_index_in_client
 * @property {GUID} hypeUserId - the unique id of a hype user
 * @property {string} screenPart - screen_part
 * @property {string} hoppUserProfiles - hopp_user_profiles
 * @property {GUID} uouClientId - uou_client_id
 * @property {number} windowHeight - window_height
 * @property {string} panelName - panel_name
 * @property {number} uouIndexInSession - uou_index_in_session
 * @property {string} origin - current screen/tab/specific description of location
 * @property {GUID} uouSessionId - uou_session_id
 * @property {number} screenWidth - screen_width
 * @property {string} environment - environment
 * @property {string} dialogName - dialog_name
 * @property {number} screenHeight - screen_height
 * @property {string} uouReferrer - uou_referrer
 * @property {string} pageName - page_name
 * @property {string} type - type
 * @property {number} windowWidth - window_width
 * @property {string} value - the value
 * @return {LogObject<uSwitchPreviewClickedParams>} LogObject<uSwitchPreviewClickedParams>
 */
export function uSwitchPreviewClicked(params) {
    return { evid: 16, src: 146, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uListItemDeselected' event (evid: 17)
 *
 * Event description: When a user selects/unselects a specific item such as a contact or a link
 *
 * @param {uListItemDeselectedParams} params - The parameters for this event
 * @property {number} uouIndexInClient - uou_index_in_client
 * @property {GUID} hypeUserId - the unique id of a hype user
 * @property {string} screenPart - screen_part
 * @property {string} hoppUserProfiles - hopp_user_profiles
 * @property {GUID} uouClientId - uou_client_id
 * @property {number} windowHeight - window_height
 * @property {string} panelName - panel_name
 * @property {number} uouIndexInSession - uou_index_in_session
 * @property {string} origin - current screen/tab/specific description of location
 * @property {GUID} uouSessionId - uou_session_id
 * @property {boolean} isSelected - true if current action was to select
 * @property {number} screenWidth - screen_width
 * @property {string} itemType - the type of the item (contact/list/link..)
 * @property {string} environment - environment
 * @property {string} dialogName - dialog_name
 * @property {number} screenHeight - screen_height
 * @property {string} itemName - the name of the specific item (the specific action/link..)
 * @property {string} uouReferrer - uou_referrer
 * @property {string} pageName - page_name
 * @property {string} type - type
 * @property {number} windowWidth - window_width
 * @return {LogObject<uListItemDeselectedParams>} LogObject<uListItemDeselectedParams>
 */
export function uListItemDeselected(params) {
    return { evid: 17, src: 146, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uTemplateColorPaletteChanged' event (evid: 19)
 *
 * Event description: When user changes site's palette
 *
 * @param {uTemplateColorPaletteChangedParams} params - The parameters for this event
 * @property {number} uouIndexInClient - uou_index_in_client
 * @property {GUID} hypeUserId - the unique id of a hype user
 * @property {string} screenPart - screen_part
 * @property {string} hoppUserProfiles - hopp_user_profiles
 * @property {GUID} uouClientId - uou_client_id
 * @property {number} windowHeight - window_height
 * @property {string} panelName - panel_name
 * @property {number} uouIndexInSession - uou_index_in_session
 * @property {string} origin - current screen/tab/specific description of location
 * @property {GUID} uouSessionId - uou_session_id
 * @property {number} screenWidth - screen_width
 * @property {string} environment - environment
 * @property {string} dialogName - dialog_name
 * @property {number} screenHeight - screen_height
 * @property {string} uouReferrer - uou_referrer
 * @property {string} pageName - page_name
 * @property {string} type - type
 * @property {number} windowWidth - window_width
 * @property {string} value - the value
 * @return {LogObject<uTemplateColorPaletteChangedParams>} LogObject<uTemplateColorPaletteChangedParams>
 */
export function uTemplateColorPaletteChanged(params) {
    return { evid: 19, src: 146, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uButtonClickedFromDialogNoInput' event (evid: 2)
 *
 * Event description: The premium flow ended by the user
 *
 * @param {uButtonClickedFromDialogNoInputParams} params - The parameters for this event
 * @property {number} uouIndexInClient - uou_index_in_client
 * @property {GUID} hypeUserId - unique hype user id
 * @property {string} screenPart - screen_part
 * @property {string} flowType - flow type
 * @property {string} hoppUserProfiles - hopp_user_profiles
 * @property {GUID} uouClientId - uou_client_id
 * @property {number} windowHeight - window_height
 * @property {string} panelName - panel_name
 * @property {number} uouIndexInSession - uou_index_in_session
 * @property {string} origin - current screen/tab/specific description of location
 * @property {GUID} uouSessionId - uou_session_id
 * @property {number} screenWidth - screen_width
 * @property {string} environment - environment
 * @property {string} dialogName - dialog_name
 * @property {string} buttonName - the name of the button clicked
 * @property {number} screenHeight - screen_height
 * @property {string} uouReferrer - uou_referrer
 * @property {string} pageName - page_name
 * @property {string} type - type
 * @property {number} windowWidth - window_width
 * @return {LogObject<uButtonClickedFromDialogNoInputParams>} LogObject<uButtonClickedFromDialogNoInputParams>
 */
export function uButtonClickedFromDialogNoInput(params) {
    return { evid: 2, src: 146, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uError' event (evid: 20)
 *
 * Event description: When an error is shown to user
 *
 * @param {uErrorParams} params - The parameters for this event
 * @property {number} uouIndexInClient - uou_index_in_client
 * @property {GUID} hypeUserId - the unique id of a hype user
 * @property {string} screenPart - screen_part
 * @property {string} errorMessage - the message shown when the error appears
 * @property {string} hoppUserProfiles - hopp_user_profiles
 * @property {GUID} uouClientId - uou_client_id
 * @property {string} errorType - type of the error
 * @property {number} windowHeight - window_height
 * @property {string} panelName - panel_name
 * @property {number} uouIndexInSession - uou_index_in_session
 * @property {string} origin - current screen/tab/specific description of location
 * @property {GUID} uouSessionId - uou_session_id
 * @property {number} screenWidth - screen_width
 * @property {string} environment - environment
 * @property {string} actionName - name of the action (for error name of action error occured from)
 * @property {string} dialogName - dialog_name
 * @property {string} requestId - the id of the request sent with the error
 * @property {number} screenHeight - screen_height
 * @property {string} uouReferrer - uou_referrer
 * @property {string} pageName - page_name
 * @property {string} type - type
 * @property {number} windowWidth - window_width
 * @return {LogObject<uErrorParams>} LogObject<uErrorParams>
 */
export function uError(params) {
    return { evid: 20, src: 146, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uActionCreated' event (evid: 24)
 *
 * Event description: When user clicks on add from action dialog with title field
 *
 * @param {uActionCreatedParams} params - The parameters for this event
 * @property {number} uouIndexInClient - uou_index_in_client
 * @property {GUID} hypeUserId - the unique id of a hype user
 * @property {string} screenPart - screen_part
 * @property {string} hoppUserProfiles - hopp_user_profiles
 * @property {GUID} uouClientId - uou_client_id
 * @property {string} pageId - pageId
 * @property {number} windowHeight - window_height
 * @property {string} panelName - panel_name
 * @property {number} uouIndexInSession - uou_index_in_session
 * @property {string} origin - origin
 * @property {GUID} uouSessionId - uou_session_id
 * @property {number} screenWidth - screen_width
 * @property {string} environment - environment
 * @property {string} actionName - name of the action (for error name of action error occured from)
 * @property {string} dialogName - dialog_name
 * @property {number} screenHeight - screen_height
 * @property {string} uouReferrer - uou_referrer
 * @property {string} pageName - page_name
 * @property {string} title - the title field
 * @property {string} type - type
 * @property {number} windowWidth - window_width
 * @property {string} inputJson - json of all fields and the chosen values
 * @return {LogObject<uActionCreatedParams>} LogObject<uActionCreatedParams>
 */
export function uActionCreated(params) {
    return { evid: 24, src: 146, endpoint: '', params };
}
/**
 * A function to create a log object for the 'promotionalAssetSawSrc146Evid249' event (evid: 249)
 *
 * Event description: User Saw Promotional Asset
 *
 * @param {promotionalAssetSawSrc146Evid249Params} params - The parameters for this event
 * @property {string} name - name of the asset
 * @property {string} origin - the page name
 * @property {string} flowType - flow type
 * @property {string} actionContext - the context in which promotion was shown
 * @property {string} assetId - asset identifier
 * @property {GUID} hypeUserId - hype user ID
 * @return {LogObject<promotionalAssetSawSrc146Evid249Params>} LogObject<promotionalAssetSawSrc146Evid249Params>
 */
export function promotionalAssetSawSrc146Evid249(params) {
    return { evid: 249, src: 146, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uChangedProperty' event (evid: 25)
 *
 * Event description: When user changes an input field or a selection of a property like color
 *
 * @param {uChangedPropertyParams} params - The parameters for this event
 * @property {number} uouIndexInClient - uou_index_in_client
 * @property {GUID} hypeUserId - the unique id of a hype user
 * @property {string} screenPart - screen_part
 * @property {string} hoppUserProfiles - hopp_user_profiles
 * @property {GUID} uouClientId - uou_client_id
 * @property {number} windowHeight - window_height
 * @property {string} panelName - panel_name
 * @property {number} uouIndexInSession - uou_index_in_session
 * @property {string} origin - current screen/tab/specific description of location
 * @property {GUID} uouSessionId - uou_session_id
 * @property {number} screenWidth - screen_width
 * @property {string} environment - environment
 * @property {string} dialogName - dialog_name
 * @property {number} screenHeight - screen_height
 * @property {string} uouReferrer - uou_referrer
 * @property {string} propertyValue - the new value of the changed property
 * @property {string} pageName - page_name
 * @property {string} propertyName - the name of the changed property
 * @property {string} type - type
 * @property {number} windowWidth - window_width
 * @return {LogObject<uChangedPropertyParams>} LogObject<uChangedPropertyParams>
 */
export function uChangedProperty(params) {
    return { evid: 25, src: 146, endpoint: '', params };
}
/**
 * A function to create a log object for the 'promotionalAssetClickSrc146Evid250' event (evid: 250)
 *
 * Event description: Actions in promotional asset
 *
 * @param {promotionalAssetClickSrc146Evid250Params} params - The parameters for this event
 * @property {string} name - name of the asset
 * @property {string} origin - the page name
 * @property {string} flowType - flow type
 * @property {string} assetId - asset identifier
 * @property {string} actionContext - the context in which promotion was shown
 * @property {string} actiontype - click, close, select
 * @property {string} 'action name' - action name
 * @return {LogObject<promotionalAssetClickSrc146Evid250Params>} LogObject<promotionalAssetClickSrc146Evid250Params>
 */
export function promotionalAssetClickSrc146Evid250(params) {
    return { evid: 250, src: 146, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uouLinkClicked' event (evid: 26)
 *
 * Event description: When user clicks on link
 *
 * @param {uouLinkClickedParams} params - The parameters for this event
 * @property {number} uouIndexInClient - uou_index_in_client
 * @property {GUID} hypeUserId - the unique id of a hype user
 * @property {string} screenPart - screen_part
 * @property {string} hoppUserProfiles - hopp_user_profiles
 * @property {GUID} uouClientId - uou_client_id
 * @property {number} windowHeight - window_height
 * @property {string} panelName - panel_name
 * @property {number} uouIndexInSession - uou_index_in_session
 * @property {string} origin - current screen/tab/specific description of location
 * @property {GUID} uouSessionId - uou_session_id
 * @property {number} screenWidth - screen_width
 * @property {string} link - the link/ identifier
 * @property {string} environment - environment
 * @property {string} dialogName - dialog_name
 * @property {number} screenHeight - screen_height
 * @property {string} uouReferrer - uou_referrer
 * @property {string} pageName - page_name
 * @property {string} type - type
 * @property {number} windowWidth - window_width
 * @return {LogObject<uouLinkClickedParams>} LogObject<uouLinkClickedParams>
 */
export function uouLinkClicked(params) {
    return { evid: 26, src: 146, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uouPageViewed' event (evid: 28)
 *
 * Event description: When uou views a page
 *
 * @param {uouPageViewedParams} params - The parameters for this event
 * @property {number} uouIndexInClient - uou_index_in_client
 * @property {GUID} hypeUserId - hype_user_id
 * @property {string} screenPart - screen_part
 * @property {string} linkId - link id
 * @property {string} hoppUserProfiles - hopp_user_profiles
 * @property {GUID} uouClientId - uou_client_id
 * @property {string} pageId - page id
 * @property {number} windowHeight - window_height
 * @property {string} destinationUrl - string
 * @property {string} panelName - panel_name
 * @property {number} uouIndexInSession - uou_index_in_session
 * @property {string} origin - origin
 * @property {GUID} uouSessionId - uou_session_id
 * @property {number} screenWidth - screen_width
 * @property {string} environment - environment
 * @property {string} dialogName - dialog_name
 * @property {number} screenHeight - screen_height
 * @property {string} pageType - page type
 * @property {string} uouReferrer - uou_referrer
 * @property {string} pageName - page_name
 * @property {string} type - type
 * @property {number} windowWidth - window_width
 * @return {LogObject<uouPageViewedParams>} LogObject<uouPageViewedParams>
 */
export function uouPageViewed(params) {
    return { evid: 28, src: 146, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uouActionViewed' event (evid: 29)
 *
 * Event description: When uou views an action
 *
 * @param {uouActionViewedParams} params - The parameters for this event
 * @property {number} uouIndexInClient - uou_index_in_client
 * @property {GUID} hypeUserId - hype_user_id
 * @property {string} screenPart - screen_part
 * @property {string} linkId - link id
 * @property {string} actionId - action id
 * @property {string} hoppUserProfiles - hopp_user_profiles
 * @property {GUID} uouClientId - uou_client_id
 * @property {string} pageId - page id
 * @property {string} actionType - type of the action
 * @property {number} windowHeight - window_height
 * @property {string} destinationUrl - destination url
 * @property {number} itemPosition - position of the item
 * @property {string} panelName - panel_name
 * @property {number} uouIndexInSession - uou_index_in_session
 * @property {string} origin - origin
 * @property {GUID} uouSessionId - uou_session_id
 * @property {number} screenWidth - screen_width
 * @property {string} environment - environment
 * @property {string} dialogName - dialog_name
 * @property {number} screenHeight - screen_height
 * @property {string} pageType - page type
 * @property {string} uouReferrer - uou_referrer
 * @property {string} pageName - page_name
 * @property {string} type - type
 * @property {number} windowWidth - window_width
 * @property {string} sourceType - sourceType
 * @return {LogObject<uouActionViewedParams>} LogObject<uouActionViewedParams>
 */
export function uouActionViewed(params) {
    return { evid: 29, src: 146, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uDialogButtonClicked' event (evid: 3)
 *
 * Event description: When user clicks on a button from a dialog in which he filled input information
 *
 * @param {uDialogButtonClickedParams} params - The parameters for this event
 * @property {number} uouIndexInClient - uou_index_in_client
 * @property {GUID} hypeUserId - unique hype user id
 * @property {string} screenPart - screen_part
 * @property {string} hoppUserProfiles - hopp_user_profiles
 * @property {GUID} uouClientId - uou_client_id
 * @property {number} windowHeight - window_height
 * @property {string} panelName - panel_name
 * @property {number} uouIndexInSession - uou_index_in_session
 * @property {string} origin - current screen/tab/specific description of location
 * @property {GUID} uouSessionId - uou_session_id
 * @property {number} screenWidth - screen_width
 * @property {string} environment - environment
 * @property {string} dialogName - dialog_name
 * @property {string} buttonName - the name of the button clicked
 * @property {number} screenHeight - screen_height
 * @property {string} uouReferrer - uou_referrer
 * @property {string} pageName - page_name
 * @property {string} type - type
 * @property {number} windowWidth - window_width
 * @property {string} inputJson - json of all fields and the chosen values
 * @return {LogObject<uDialogButtonClickedParams>} LogObject<uDialogButtonClickedParams>
 */
export function uDialogButtonClicked(params) {
    return { evid: 3, src: 146, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uouPageSkipClicked' event (evid: 30)
 *
 * Event description: When uou clicks on skip page
 *
 * @param {uouPageSkipClickedParams} params - The parameters for this event
 * @property {number} uouIndexInClient - uou_index_in_client
 * @property {GUID} hypeUserId - hype_user_id
 * @property {string} screenPart - screen_part
 * @property {string} linkId - link id
 * @property {string} hoppUserProfiles - hopp_user_profiles
 * @property {GUID} uouClientId - uou_client_id
 * @property {string} pageId - page id
 * @property {number} windowHeight - window_height
 * @property {string} destinationUrl - destination url
 * @property {string} panelName - panel_name
 * @property {number} uouIndexInSession - uou_index_in_session
 * @property {string} origin - origin
 * @property {GUID} uouSessionId - uou_session_id
 * @property {number} screenWidth - screen_width
 * @property {string} environment - environment
 * @property {string} dialogName - dialog_name
 * @property {number} screenHeight - screen_height
 * @property {string} uouReferrer - uou_referrer
 * @property {string} pageName - page_name
 * @property {string} type - type
 * @property {number} windowWidth - window_width
 * @return {LogObject<uouPageSkipClickedParams>} LogObject<uouPageSkipClickedParams>
 */
export function uouPageSkipClicked(params) {
    return { evid: 30, src: 146, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uouActionClicked' event (evid: 31)
 *
 * Event description: When uou achieves goal of action
 *
 * @param {uouActionClickedParams} params - The parameters for this event
 * @property {number} uouIndexInClient - uou_index_in_client
 * @property {GUID} hypeUserId - hype_user_id
 * @property {string} screenPart - screen_part
 * @property {string} linkId - link id
 * @property {string} actionId - action id
 * @property {string} hoppUserProfiles - hopp_user_profiles
 * @property {GUID} uouClientId - uou_client_id
 * @property {string} pageId - page id
 * @property {string} innerItemId - inner item id
 * @property {string} actionType - describes the type of action that was clicked
 * @property {number} windowHeight - window_height
 * @property {string} destinationUrl - destination url
 * @property {number} itemPosition - describes the position of the item
 * @property {string} panelName - panel_name
 * @property {number} uouIndexInSession - uou_index_in_session
 * @property {string} origin - origin
 * @property {GUID} uouSessionId - uou_session_id
 * @property {number} screenWidth - screen_width
 * @property {string} environment - environment
 * @property {string} dialogName - dialog_name
 * @property {number} screenHeight - screen_height
 * @property {string} pageType - page type
 * @property {string} uouReferrer - uou_referrer
 * @property {string} pageName - page_name
 * @property {string} type - type
 * @property {number} windowWidth - window_width
 * @property {string} goalType - This is the goal type: link click, submit, payment...
 * @property {string} goalSource - The source of the goal, search, page, etc...
 * @return {LogObject<uouActionClickedParams>} LogObject<uouActionClickedParams>
 */
export function uouActionClicked(params) {
    return { evid: 31, src: 146, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uouDestinationRedirectedSrc146Evid33' event (evid: 33)
 *
 * Event description: When uou was redirected to destination
 *
 * @param {uouDestinationRedirectedSrc146Evid33Params} params - The parameters for this event
 * @property {number} uouIndexInClient - uou_index_in_client
 * @property {GUID} hypeUserId - hype_user_id
 * @property {string} screenPart - screen_part
 * @property {string} linkId - link id
 * @property {string} hoppUserProfiles - hopp_user_profiles
 * @property {GUID} uouClientId - uou_client_id
 * @property {string} pageId - page id
 * @property {number} windowHeight - window_height
 * @property {string} destinationUrl - destination url
 * @property {string} panelName - panel_name
 * @property {number} uouIndexInSession - uou_index_in_session
 * @property {string} origin - origin
 * @property {GUID} uouSessionId - uou_session_id
 * @property {number} screenWidth - screen_width
 * @property {string} environment - environment
 * @property {string} dialogName - dialog_name
 * @property {number} screenHeight - screen_height
 * @property {string} uouReferrer - uou_referrer
 * @property {string} pageName - page_name
 * @property {boolean} passthrough - passthrough
 * @property {string} type - type
 * @property {number} windowWidth - window_width
 * @return {LogObject<uouDestinationRedirectedSrc146Evid33Params>} LogObject<uouDestinationRedirectedSrc146Evid33Params>
 */
export function uouDestinationRedirectedSrc146Evid33(params) {
    return { evid: 33, src: 146, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uListItemReordered' event (evid: 34)
 *
 * Event description: When user drags an item and reorders the list
 *
 * @param {uListItemReorderedParams} params - The parameters for this event
 * @property {string} targetOrder - the new order
 * @property {number} uouIndexInClient - uou_index_in_client
 * @property {GUID} hypeUserId - hype_user_id
 * @property {string} screenPart - screen_part
 * @property {string} hoppUserProfiles - hopp_user_profiles
 * @property {GUID} uouClientId - uou_client_id
 * @property {number} windowHeight - window_height
 * @property {string} panelName - panel_name
 * @property {string} currentOrder - the order before change
 * @property {number} uouIndexInSession - uou_index_in_session
 * @property {string} origin - origin
 * @property {GUID} uouSessionId - uou_session_id
 * @property {number} screenWidth - screen_width
 * @property {string} itemType - the type of the item (contact/list/link..)
 * @property {string} environment - environment
 * @property {string} dialogName - dialog_name
 * @property {number} screenHeight - screen_height
 * @property {string} itemName - the specific item
 * @property {string} uouReferrer - uou_referrer
 * @property {string} pageName - page_name
 * @property {string} type - type
 * @property {number} windowWidth - window_width
 * @return {LogObject<uListItemReorderedParams>} LogObject<uListItemReorderedParams>
 */
export function uListItemReordered(params) {
    return { evid: 34, src: 146, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uouToggleAction' event (evid: 35)
 *
 * Event description: When uou clicked on the actions in the toggle (created on 05/04, ignore events occurred before).
 *
 * @param {uouToggleActionParams} params - The parameters for this event
 * @property {number} uouIndexInClient - uou_index_in_client
 * @property {GUID} hypeUserId - hype_user_id
 * @property {string} screenPart - screen_part
 * @property {string} linkId - link id
 * @property {string} state - state
 * @property {string} actionId - action_id
 * @property {string} hoppUserProfiles - hopp_user_profiles
 * @property {GUID} uouClientId - uou_client_id
 * @property {string} pageId - page_id
 * @property {string} actionType - action type
 * @property {number} windowHeight - window_height
 * @property {string} destinationUrl - destination url
 * @property {number} itemPosition - item position
 * @property {string} panelName - panel_name
 * @property {number} uouIndexInSession - uou_index_in_session
 * @property {string} origin - origin
 * @property {GUID} uouSessionId - uou_session_id
 * @property {number} screenWidth - screen_width
 * @property {string} environment - environment
 * @property {string} dialogName - dialog_name
 * @property {number} screenHeight - screen_height
 * @property {string} uouReferrer - uou_referrer
 * @property {string} pageName - page_name
 * @property {string} type - type
 * @property {number} windowWidth - window_width
 * @return {LogObject<uouToggleActionParams>} LogObject<uouToggleActionParams>
 */
export function uouToggleAction(params) {
    return { evid: 35, src: 146, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uPageLoaded' event (evid: 36)
 *
 * Event description: When page loads
 *
 * @param {uPageLoadedParams} params - The parameters for this event
 * @property {number} uouIndexInClient - uou_index_in_client
 * @property {GUID} hypeUserId - hype_user_id
 * @property {string} screenPart - screen_part
 * @property {string} hoppUserProfiles - hopp_user_profiles
 * @property {GUID} uouClientId - uou_client_id
 * @property {number} windowHeight - window_height
 * @property {string} panelName - panel_name
 * @property {number} uouIndexInSession - uou_index_in_session
 * @property {string} origin - origin
 * @property {GUID} uouSessionId - uou_session_id
 * @property {number} screenWidth - screen_width
 * @property {string} environment - environment
 * @property {string} dialogName - dialog_name
 * @property {number} screenHeight - screen_height
 * @property {string} uouReferrer - uou_referrer
 * @property {string} pageName - page_name
 * @property {string} type - type
 * @property {number} windowWidth - window_width
 * @return {LogObject<uPageLoadedParams>} LogObject<uPageLoadedParams>
 */
export function uPageLoaded(params) {
    return { evid: 36, src: 146, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uLinkAdded' event (evid: 37)
 *
 * Event description: when a new link is being added
 *
 * @param {uLinkAddedParams} params - The parameters for this event
 * @property {number} uouIndexInClient - uou_index_in_client
 * @property {GUID} hypeUserId - hype_user_id
 * @property {string} screenPart - screen_part
 * @property {string} linkId - link_id
 * @property {string} linkUrl - url
 * @property {string} hoppUserProfiles - hopp_user_profiles
 * @property {GUID} uouClientId - uou_client_id
 * @property {string} pageId - page id
 * @property {number} windowHeight - window_height
 * @property {string} panelName - panel_name
 * @property {number} uouIndexInSession - uou_index_in_session
 * @property {string} origin - origin
 * @property {GUID} uouSessionId - uou_session_id
 * @property {number} screenWidth - screen_width
 * @property {string} environment - environment
 * @property {string} dialogName - dialog_name
 * @property {number} screenHeight - screen_height
 * @property {string} uouReferrer - uou_referrer
 * @property {string} pageName - page_name
 * @property {string} type - type
 * @property {number} windowWidth - window_width
 * @return {LogObject<uLinkAddedParams>} LogObject<uLinkAddedParams>
 */
export function uLinkAdded(params) {
    return { evid: 37, src: 146, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uLinkEdited' event (evid: 38)
 *
 * Event description: when a link has been edited
 *
 * @param {uLinkEditedParams} params - The parameters for this event
 * @property {number} uouIndexInClient - uou_index_in_client
 * @property {GUID} hypeUserId - hype_user_id
 * @property {string} screenPart - screen_part
 * @property {string} linkId - link_id
 * @property {string} linkUrl - url
 * @property {string} hoppUserProfiles - hopp_user_profiles
 * @property {GUID} uouClientId - uou_client_id
 * @property {string} pageId - page_id
 * @property {number} windowHeight - window_height
 * @property {string} panelName - panel_name
 * @property {number} uouIndexInSession - uou_index_in_session
 * @property {string} origin - origin
 * @property {GUID} uouSessionId - uou_session_id
 * @property {number} screenWidth - screen_width
 * @property {string} environment - environment
 * @property {string} dialogName - dialog_name
 * @property {number} screenHeight - screen_height
 * @property {string} uouReferrer - uou_referrer
 * @property {string} pageName - page_name
 * @property {string} type - type
 * @property {number} windowWidth - window_width
 * @return {LogObject<uLinkEditedParams>} LogObject<uLinkEditedParams>
 */
export function uLinkEdited(params) {
    return { evid: 38, src: 146, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uLinkDeleted' event (evid: 39)
 *
 * Event description: when a link gets deleted
 *
 * @param {uLinkDeletedParams} params - The parameters for this event
 * @property {number} uouIndexInClient - uou_index_in_client
 * @property {GUID} hypeUserId - hype_user_id
 * @property {string} screenPart - screen_part
 * @property {string} linksDeletedId - links id of the links deleted
 * @property {string} hoppUserProfiles - hopp_user_profiles
 * @property {GUID} uouClientId - uou_client_id
 * @property {number} linksDeletedCount - num of deleted links
 * @property {number} windowHeight - window_height
 * @property {string} panelName - panel_name
 * @property {number} uouIndexInSession - uou_index_in_session
 * @property {string} origin - origin
 * @property {GUID} uouSessionId - uou_session_id
 * @property {number} screenWidth - screen_width
 * @property {string} environment - environment
 * @property {string} dialogName - dialog_name
 * @property {number} screenHeight - screen_height
 * @property {string} uouReferrer - uou_referrer
 * @property {string} pageName - page_name
 * @property {string} type - type
 * @property {number} windowWidth - window_width
 * @return {LogObject<uLinkDeletedParams>} LogObject<uLinkDeletedParams>
 */
export function uLinkDeleted(params) {
    return { evid: 39, src: 146, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uButtonClicked' event (evid: 4)
 *
 * Event description: When user clicks on a button from a screen that does not have any relevant input information
 *
 * @param {uButtonClickedParams} params - The parameters for this event
 * @property {number} uouIndexInClient - uou_index_in_client
 * @property {GUID} hypeUserId - unique hype user id
 * @property {string} screenPart - screen_part
 * @property {string} hoppUserProfiles - hopp_user_profiles
 * @property {string} features - features added in test mode before click
 * @property {GUID} uouClientId - uou_client_id
 * @property {number} windowHeight - window_height
 * @property {string} panelName - panel_name
 * @property {boolean} isTest - is in test mode
 * @property {number} uouIndexInSession - uou_index_in_session
 * @property {string} origin - current screen/tab/specific description of location
 * @property {GUID} uouSessionId - uou_session_id
 * @property {number} screenWidth - screen_width
 * @property {string} environment - environment
 * @property {string} dialogName - dialog_name
 * @property {string} buttonName - the name of the button clicked
 * @property {number} screenHeight - screen_height
 * @property {string} uouReferrer - uou_referrer
 * @property {string} pageName - page_name
 * @property {string} type - type
 * @property {number} windowWidth - window_width
 * @return {LogObject<uButtonClickedParams>} LogObject<uButtonClickedParams>
 */
export function uButtonClicked(params) {
    return { evid: 4, src: 146, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uPageEdited' event (evid: 40)
 *
 * Event description: dispatched on any page change - field/action
 *
 * @param {uPageEditedParams} params - The parameters for this event
 * @property {number} uouIndexInClient - uou_index_in_client
 * @property {GUID} hypeUserId - hype_user_id
 * @property {string} screenPart - screen_part
 * @property {string} hoppUserProfiles - hopp_user_profiles
 * @property {GUID} uouClientId - uou_client_id
 * @property {string} pageId - page id
 * @property {number} windowHeight - window_height
 * @property {string} panelName - panel_name
 * @property {number} uouIndexInSession - uou_index_in_session
 * @property {string} origin - origin
 * @property {GUID} uouSessionId - uou_session_id
 * @property {number} screenWidth - screen_width
 * @property {string} environment - environment
 * @property {string} dialogName - dialog_name
 * @property {string} prevValues - json of prev values
 * @property {number} screenHeight - screen_height
 * @property {string} uouReferrer - uou_referrer
 * @property {string} pageName - page_name
 * @property {string} type - type
 * @property {string} nextValues - next_values
 * @property {number} windowWidth - window_width
 * @return {LogObject<uPageEditedParams>} LogObject<uPageEditedParams>
 */
export function uPageEdited(params) {
    return { evid: 40, src: 146, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uActionEdited' event (evid: 41)
 *
 * Event description: dispatched on any action field changed
 *
 * @param {uActionEditedParams} params - The parameters for this event
 * @property {number} uouIndexInClient - uou_index_in_client
 * @property {GUID} hypeUserId - hype_user_id
 * @property {string} screenPart - screen_part
 * @property {string} fieldId - field id
 * @property {string} actionId - action id
 * @property {string} hoppUserProfiles - hopp_user_profiles
 * @property {GUID} uouClientId - uou_client_id
 * @property {string} pageId - page id
 * @property {string} actionType - action type
 * @property {number} windowHeight - window_height
 * @property {string} panelName - panel_name
 * @property {number} uouIndexInSession - uou_index_in_session
 * @property {string} origin - origin
 * @property {GUID} uouSessionId - uou_session_id
 * @property {number} screenWidth - screen_width
 * @property {string} environment - environment
 * @property {string} dialogName - dialog_name
 * @property {string} prevValues - json of prev values
 * @property {number} screenHeight - screen_height
 * @property {string} uouReferrer - uou_referrer
 * @property {string} pageName - page_name
 * @property {string} type - type
 * @property {string} nextValues - json of next values
 * @property {number} windowWidth - window_width
 * @return {LogObject<uActionEditedParams>} LogObject<uActionEditedParams>
 */
export function uActionEdited(params) {
    return { evid: 41, src: 146, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uActionDeleted' event (evid: 42)
 *
 * Event description: dispatched when an action gets deleted
 *
 * @param {uActionDeletedParams} params - The parameters for this event
 * @property {number} uouIndexInClient - uou_index_in_client
 * @property {GUID} hypeUserId - hype_user_id
 * @property {string} screenPart - screen_part
 * @property {string} fieldId - field id
 * @property {string} actionId - action id
 * @property {string} hoppUserProfiles - hopp_user_profiles
 * @property {GUID} uouClientId - uou_client_id
 * @property {string} pageId - page id
 * @property {string} actionType - action type
 * @property {number} windowHeight - window_height
 * @property {string} panelName - panel_name
 * @property {number} uouIndexInSession - uou_index_in_session
 * @property {string} origin - origin
 * @property {GUID} uouSessionId - uou_session_id
 * @property {number} screenWidth - screen_width
 * @property {string} environment - environment
 * @property {string} dialogName - dialog_name
 * @property {number} screenHeight - screen_height
 * @property {string} uouReferrer - uou_referrer
 * @property {string} pageName - page_name
 * @property {string} type - type
 * @property {number} windowWidth - window_width
 * @return {LogObject<uActionDeletedParams>} LogObject<uActionDeletedParams>
 */
export function uActionDeleted(params) {
    return { evid: 42, src: 146, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uouHypeBannerClicked' event (evid: 44)
 *
 * Event description: When a user of user clicks the Hype banner
 *
 * @param {uouHypeBannerClickedParams} params - The parameters for this event
 * @property {number} uouIndexInClient - uou_index_in_client
 * @property {GUID} hypeUserId - hype_user_id
 * @property {string} screenPart - screen_part
 * @property {string} linkId - link id
 * @property {string} hoppUserProfiles - hopp_user_profiles
 * @property {GUID} uouClientId - uou_client_id
 * @property {string} pageId - Page id
 * @property {number} windowHeight - window_height
 * @property {string} destinationUrl - destination url
 * @property {string} panelName - panel_name
 * @property {number} uouIndexInSession - uou_index_in_session
 * @property {string} origin - origin
 * @property {GUID} uouSessionId - uou_session_id
 * @property {number} screenWidth - screen_width
 * @property {string} environment - environment
 * @property {string} dialogName - dialog_name
 * @property {number} screenHeight - screen_height
 * @property {string} pageType - page type
 * @property {string} uouReferrer - uou_referrer
 * @property {string} pageName - page_name
 * @property {string} type - type
 * @property {number} windowWidth - window_width
 * @return {LogObject<uouHypeBannerClickedParams>} LogObject<uouHypeBannerClickedParams>
 */
export function uouHypeBannerClicked(params) {
    return { evid: 44, src: 146, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uouCloseAction' event (evid: 45)
 *
 * Event description: When uou clicked on "close" action (not on the action in the toggle).
 *
 * @param {uouCloseActionParams} params - The parameters for this event
 * @property {number} uouIndexInClient - uou_index_in_client
 * @property {GUID} hypeUserId - hype_user_id
 * @property {string} screenPart - screen_part
 * @property {string} linkId - link id
 * @property {string} actionId - action id
 * @property {string} hoppUserProfiles - hopp_user_profiles
 * @property {GUID} uouClientId - uou_client_id
 * @property {string} pageId - page id
 * @property {string} actionType - action type
 * @property {number} windowHeight - window_height
 * @property {string} destinationUrl - destination url
 * @property {number} itemPosition - position of item
 * @property {string} panelName - panel_name
 * @property {number} uouIndexInSession - uou_index_in_session
 * @property {string} origin - origin
 * @property {GUID} uouSessionId - uou_session_id
 * @property {number} screenWidth - screen_width
 * @property {string} environment - environment
 * @property {string} dialogName - dialog_name
 * @property {number} screenHeight - screen_height
 * @property {string} uouReferrer - uou_referrer
 * @property {string} pageName - page_name
 * @property {string} type - type
 * @property {number} windowWidth - window_width
 * @return {LogObject<uouCloseActionParams>} LogObject<uouCloseActionParams>
 */
export function uouCloseAction(params) {
    return { evid: 45, src: 146, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uouPageVisibilityChange' event (evid: 46)
 *
 * Event description: Page active
 *
 * @param {uouPageVisibilityChangeParams} params - The parameters for this event
 * @property {number} uouIndexInClient - uou_index_in_client
 * @property {GUID} hypeUserId - hype_user_id
 * @property {string} screenPart - screen_part
 * @property {string} linkId - link id
 * @property {string} state - state
 * @property {string} hoppUserProfiles - hopp_user_profiles
 * @property {GUID} uouClientId - uou_client_id
 * @property {string} pageId - page id
 * @property {number} windowHeight - window_height
 * @property {string} destinationUrl - destination url
 * @property {string} panelName - panel_name
 * @property {number} uouIndexInSession - uou_index_in_session
 * @property {string} origin - origin
 * @property {GUID} uouSessionId - uou_session_id
 * @property {number} screenWidth - screen_width
 * @property {string} environment - environment
 * @property {string} dialogName - dialog_name
 * @property {number} screenHeight - screen_height
 * @property {string} pageType - page type
 * @property {string} uouReferrer - uou_referrer
 * @property {string} pageName - page_name
 * @property {string} type - type
 * @property {number} windowWidth - window_width
 * @return {LogObject<uouPageVisibilityChangeParams>} LogObject<uouPageVisibilityChangeParams>
 */
export function uouPageVisibilityChange(params) {
    return { evid: 46, src: 146, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uUtm' event (evid: 47)
 *
 * Event description: when users comes from campaign. Urchin Tracking Module (UTM) parameters are five variants of URL parameters used by marketers to track the effectiveness of online marketing campaigns across traffic sources and publishing media.
 *
 * @param {uUtmParams} params - The parameters for this event
 * @property {string} utmCampaign - identify specific product promotion or strategic campaign
 * @property {number} uouIndexInClient - uou_index_in_client
 * @property {string} utm_source - identify search engine, newsletter name or other source
 * @property {GUID} hypeUserId - hype_user_id
 * @property {string} screenPart - screen_part
 * @property {string} utmContent - Used for A/B testing and content-targeted ads. Use utm_content to differentiate ads or links that point to the same URL.
 * @property {boolean} isWix - whether the campaign is Wix co-op
 * @property {string} hoppUserProfiles - hopp_user_profiles
 * @property {GUID} uouClientId - uou_client_id
 * @property {string} utmMedium - identify a medium such as email or cost-per-click
 * @property {number} windowHeight - window_height
 * @property {string} panelName - panel_name
 * @property {number} uouIndexInSession - uou_index_in_session
 * @property {string} origin - origin
 * @property {GUID} uouSessionId - uou_session_id
 * @property {string} utmId - identify with ads campaign this referral reference.
 * @property {number} screenWidth - screen_width
 * @property {string} utmTerm - keyword for the ad
 * @property {string} environment - environment
 * @property {string} dialogName - dialog_name
 * @property {number} screenHeight - screen_height
 * @property {string} uouReferrer - uou_referrer
 * @property {string} pageName - page_name
 * @property {string} type - type
 * @property {number} windowWidth - window_width
 * @property {string} wixClientId - the client_id of hopp.co domain
 * @property {string} partner - Helps track custom onboarding flows created for specific partners
 * @property {string} businessSegment - business Segment
 * @return {LogObject<uUtmParams>} LogObject<uUtmParams>
 */
export function uUtm(params) {
    return { evid: 47, src: 146, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uouAutoRedirectTriggered' event (evid: 48)
 *
 * Event description: when auto redirect is triggered for uou
 *
 * @param {uouAutoRedirectTriggeredParams} params - The parameters for this event
 * @property {number} uouIndexInClient - uou_index_in_client
 * @property {GUID} hypeUserId - hype_user_id
 * @property {string} screenPart - screen_part
 * @property {string} linkId - link id
 * @property {string} contextMetaData - context metadata
 * @property {string} actionId - action id
 * @property {string} hoppUserProfiles - hopp_user_profiles
 * @property {GUID} uouClientId - uou_client_id
 * @property {string} pageId - page id
 * @property {string} actionType - action type
 * @property {number} windowHeight - window_height
 * @property {string} destinationUrl - destination url
 * @property {string} panelName - panel_name
 * @property {number} uouIndexInSession - uou_index_in_session
 * @property {string} origin - origin
 * @property {GUID} uouSessionId - uou_session_id
 * @property {number} screenWidth - screen_width
 * @property {string} environment - environment
 * @property {string} dialogName - dialog_name
 * @property {number} screenHeight - screen_height
 * @property {string} uouReferrer - uou_referrer
 * @property {string} pageName - page_name
 * @property {string} type - type
 * @property {number} windowWidth - window_width
 * @return {LogObject<uouAutoRedirectTriggeredParams>} LogObject<uouAutoRedirectTriggeredParams>
 */
export function uouAutoRedirectTriggered(params) {
    return { evid: 48, src: 146, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uouAutoRedirected' event (evid: 49)
 *
 * Event description: when uou is auto redirected
 *
 * @param {uouAutoRedirectedParams} params - The parameters for this event
 * @property {number} uouIndexInClient - uou_index_in_client
 * @property {GUID} hypeUserId - hype_user_id
 * @property {string} screenPart - screen_part
 * @property {string} linkId - link id
 * @property {string} contextMetaData - context metadata
 * @property {string} actionId - action id
 * @property {string} hoppUserProfiles - hopp_user_profiles
 * @property {GUID} uouClientId - uou_client_id
 * @property {string} pageId - page id
 * @property {string} actionType - action type
 * @property {number} windowHeight - window_height
 * @property {string} destinationUrl - destination url
 * @property {string} panelName - panel_name
 * @property {number} uouIndexInSession - uou_index_in_session
 * @property {string} origin - origin
 * @property {GUID} uouSessionId - uou_session_id
 * @property {number} screenWidth - screen_width
 * @property {string} environment - environment
 * @property {string} dialogName - dialog_name
 * @property {number} screenHeight - screen_height
 * @property {string} uouReferrer - uou_referrer
 * @property {string} pageName - page_name
 * @property {string} type - type
 * @property {number} windowWidth - window_width
 * @return {LogObject<uouAutoRedirectedParams>} LogObject<uouAutoRedirectedParams>
 */
export function uouAutoRedirected(params) {
    return { evid: 49, src: 146, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uButtonClickedFromScreenWithInput' event (evid: 5)
 *
 * Event description: When user clicks on a button from a screen in which he filled input information
 *
 * @param {uButtonClickedFromScreenWithInputParams} params - The parameters for this event
 * @property {number} uouIndexInClient - uou_index_in_client
 * @property {GUID} hypeUserId - unique hype user id
 * @property {string} screenPart - screen_part
 * @property {string} hoppUserProfiles - hopp_user_profiles
 * @property {GUID} uouClientId - uou_client_id
 * @property {number} windowHeight - window_height
 * @property {string} panelName - panel_name
 * @property {number} uouIndexInSession - uou_index_in_session
 * @property {string} origin - current screen/tab/specific description of location
 * @property {GUID} uouSessionId - uou_session_id
 * @property {string} cycleName - the cycle that the user chose
 * @property {number} screenWidth - screen_width
 * @property {string} environment - environment
 * @property {string} dialogName - dialog_name
 * @property {string} buttonName - the name of the button
 * @property {number} screenHeight - screen_height
 * @property {string} uouReferrer - uou_referrer
 * @property {string} pageName - page_name
 * @property {string} type - type
 * @property {number} windowWidth - window_width
 * @property {string} inputJson - json of all fields and the chosen values
 * @property {number} sale - discount percentage
 * @property {string} packageId - package_id
 * @property {string} packageName - elite, ultimate, essential
 * @return {LogObject<uButtonClickedFromScreenWithInputParams>} LogObject<uButtonClickedFromScreenWithInputParams>
 */
export function uButtonClickedFromScreenWithInput(params) {
    return { evid: 5, src: 146, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uouAutoRedirectCanceledV2' event (evid: 50)
 *
 * Event description: when uou auto redirect is canceled
 *
 * @param {uouAutoRedirectCanceledV2Params} params - The parameters for this event
 * @property {number} uouIndexInClient - uou_index_in_client
 * @property {GUID} hypeUserId - hype_user_id
 * @property {string} screenPart - screen_part
 * @property {string} linkId - link id
 * @property {string} contextMetaData - context metadata
 * @property {string} actionId - action id
 * @property {string} hoppUserProfiles - hopp_user_profiles
 * @property {GUID} uouClientId - uou_client_id
 * @property {string} pageId - page id
 * @property {string} actionType - action type
 * @property {number} windowHeight - window_height
 * @property {string} destinationUrl - destination url
 * @property {string} panelName - panel_name
 * @property {number} uouIndexInSession - uou_index_in_session
 * @property {string} origin - origin
 * @property {GUID} uouSessionId - uou_session_id
 * @property {number} screenWidth - screen_width
 * @property {string} environment - environment
 * @property {string} dialogName - dialog_name
 * @property {number} screenHeight - screen_height
 * @property {string} uouReferrer - uou_referrer
 * @property {string} pageName - page_name
 * @property {string} type - type
 * @property {number} windowWidth - window_width
 * @return {LogObject<uouAutoRedirectCanceledV2Params>} LogObject<uouAutoRedirectCanceledV2Params>
 */
export function uouAutoRedirectCanceledV2(params) {
    return { evid: 50, src: 146, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uouPageUnload' event (evid: 51)
 *
 * Event description: When uou page unloaded
 *
 * @param {uouPageUnloadParams} params - The parameters for this event
 * @property {number} uouIndexInClient - uou_index_in_client
 * @property {GUID} hypeUserId - hype_user_id
 * @property {string} screenPart - screen_part
 * @property {string} linkId - link id
 * @property {string} hoppUserProfiles - hopp_user_profiles
 * @property {GUID} uouClientId - uou_client_id
 * @property {string} pageId - page id
 * @property {number} windowHeight - window_height
 * @property {string} destinationUrl - destination url
 * @property {string} panelName - panel_name
 * @property {number} uouIndexInSession - uou_index_in_session
 * @property {string} origin - origin
 * @property {GUID} uouSessionId - uou_session_id
 * @property {number} screenWidth - screen_width
 * @property {string} environment - environment
 * @property {string} dialogName - dialog_name
 * @property {number} screenHeight - screen_height
 * @property {string} pageType - page type
 * @property {string} uouReferrer - uou_referrer
 * @property {string} pageName - page_name
 * @property {string} type - type
 * @property {number} windowWidth - window_width
 * @return {LogObject<uouPageUnloadParams>} LogObject<uouPageUnloadParams>
 */
export function uouPageUnload(params) {
    return { evid: 51, src: 146, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uouBounced' event (evid: 52)
 *
 * Event description: When uou Bounced
 *
 * @param {uouBouncedParams} params - The parameters for this event
 * @property {number} uouIndexInClient - uou_index_in_client
 * @property {GUID} hypeUserId - hype_user_id
 * @property {string} screenPart - screen_part
 * @property {string} linkId - link id
 * @property {string} hoppUserProfiles - hopp_user_profiles
 * @property {GUID} uouClientId - uou_client_id
 * @property {string} pageId - page id
 * @property {number} windowHeight - window_height
 * @property {string} destinationUrl - destination url
 * @property {string} panelName - panel_name
 * @property {number} uouIndexInSession - uou_index_in_session
 * @property {string} origin - origin
 * @property {GUID} uouSessionId - uou_session_id
 * @property {number} screenWidth - screen_width
 * @property {string} environment - environment
 * @property {string} dialogName - dialog_name
 * @property {number} screenHeight - screen_height
 * @property {string} pageType - page type
 * @property {string} uouReferrer - uou_referrer
 * @property {string} pageName - page_name
 * @property {string} type - type
 * @property {number} windowWidth - window_width
 * @return {LogObject<uouBouncedParams>} LogObject<uouBouncedParams>
 */
export function uouBounced(params) {
    return { evid: 52, src: 146, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uouProceeded' event (evid: 53)
 *
 * Event description: When uou Proceeded
 *
 * @param {uouProceededParams} params - The parameters for this event
 * @property {number} uouIndexInClient - uou_index_in_client
 * @property {GUID} hypeUserId - hype_user_id
 * @property {string} screenPart - screen_part
 * @property {string} linkId - link id
 * @property {string} hoppUserProfiles - hopp_user_profiles
 * @property {GUID} uouClientId - uou_client_id
 * @property {string} pageId - page id
 * @property {number} windowHeight - window_height
 * @property {string} destinationUrl - destination url
 * @property {string} panelName - panel_name
 * @property {number} uouIndexInSession - uou_index_in_session
 * @property {string} origin - origin
 * @property {GUID} uouSessionId - uou_session_id
 * @property {number} screenWidth - screen_width
 * @property {string} environment - environment
 * @property {string} dialogName - dialog_name
 * @property {number} screenHeight - screen_height
 * @property {string} pageType - page type
 * @property {string} uouReferrer - uou_referrer
 * @property {string} pageName - page_name
 * @property {string} type - type
 * @property {number} windowWidth - window_width
 * @return {LogObject<uouProceededParams>} LogObject<uouProceededParams>
 */
export function uouProceeded(params) {
    return { evid: 53, src: 146, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uouActivity' event (evid: 54)
 *
 * Event description: When uou Activity
 *
 * @param {uouActivityParams} params - The parameters for this event
 * @property {number} uouIndexInClient - uou_index_in_client
 * @property {GUID} hypeUserId - hype_user_id
 * @property {string} screenPart - screen_part
 * @property {string} linkId - link id
 * @property {string} hoppUserProfiles - hopp_user_profiles
 * @property {GUID} uouClientId - uou_client_id
 * @property {string} pageId - page id
 * @property {number} windowHeight - window_height
 * @property {string} destinationUrl - destination url
 * @property {string} panelName - panel_name
 * @property {number} uouIndexInSession - uou_index_in_session
 * @property {string} origin - origin
 * @property {GUID} uouSessionId - uou_session_id
 * @property {number} screenWidth - screen_width
 * @property {string} environment - environment
 * @property {string} dialogName - dialog_name
 * @property {number} screenHeight - screen_height
 * @property {string} uouReferrer - uou_referrer
 * @property {string} pageName - page_name
 * @property {string} type - type
 * @property {number} windowWidth - window_width
 * @return {LogObject<uouActivityParams>} LogObject<uouActivityParams>
 */
export function uouActivity(params) {
    return { evid: 54, src: 146, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uouPageRefresh' event (evid: 55)
 *
 * Event description: When uou  page is refreshed
 *
 * @param {uouPageRefreshParams} params - The parameters for this event
 * @property {number} uouIndexInClient - uou_index_in_client
 * @property {GUID} hypeUserId - hype_user_id
 * @property {string} screenPart - screen_part
 * @property {string} linkId - link id
 * @property {string} hoppUserProfiles - hopp_user_profiles
 * @property {GUID} uouClientId - uou_client_id
 * @property {string} pageId - page id
 * @property {number} windowHeight - window_height
 * @property {string} destinationUrl - destination url
 * @property {string} panelName - panel_name
 * @property {number} uouIndexInSession - uou_index_in_session
 * @property {string} origin - origin
 * @property {GUID} uouSessionId - uou_session_id
 * @property {number} screenWidth - screen_width
 * @property {string} environment - environment
 * @property {string} dialogName - dialog_name
 * @property {number} screenHeight - screen_height
 * @property {string} pageType - page type
 * @property {string} uouReferrer - uou_referrer
 * @property {string} pageName - page_name
 * @property {string} type - type
 * @property {number} windowWidth - window_width
 * @return {LogObject<uouPageRefreshParams>} LogObject<uouPageRefreshParams>
 */
export function uouPageRefresh(params) {
    return { evid: 55, src: 146, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uLinksConnectedToPage' event (evid: 56)
 *
 * Event description: User Links Connected To Page
 *
 * @param {uLinksConnectedToPageParams} params - The parameters for this event
 * @property {number} uouIndexInClient - uou_index_in_client
 * @property {GUID} hypeUserId - hype_user_id
 * @property {string} screenPart - screen_part
 * @property {string} hoppUserProfiles - hopp_user_profiles
 * @property {GUID} uouClientId - uou_client_id
 * @property {string} pageId - page id
 * @property {number} windowHeight - window_height
 * @property {string} panelName - panel_name
 * @property {number} uouIndexInSession - uou_index_in_session
 * @property {number} linksCount - num of links
 * @property {string} origin - origin
 * @property {GUID} uouSessionId - uou_session_id
 * @property {number} screenWidth - screen_width
 * @property {string} environment - environment
 * @property {string} dialogName - dialog_name
 * @property {number} screenHeight - screen_height
 * @property {string} uouReferrer - uou_referrer
 * @property {string} pageName - page_name
 * @property {string} type - type
 * @property {number} windowWidth - window_width
 * @property {string} liniksIds - array of link ids
 * @return {LogObject<uLinksConnectedToPageParams>} LogObject<uLinksConnectedToPageParams>
 */
export function uLinksConnectedToPage(params) {
    return { evid: 56, src: 146, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uLinksDisconnectedFromPage' event (evid: 57)
 *
 * Event description: User Links Disconnected To Page
 *
 * @param {uLinksDisconnectedFromPageParams} params - The parameters for this event
 * @property {number} uouIndexInClient - uou_index_in_client
 * @property {GUID} hypeUserId - hype_user_id
 * @property {string} screenPart - screen_part
 * @property {string} hoppUserProfiles - hopp_user_profiles
 * @property {GUID} uouClientId - uou_client_id
 * @property {string} pageId - page id
 * @property {number} windowHeight - window_height
 * @property {string} panelName - panel_name
 * @property {number} uouIndexInSession - uou_index_in_session
 * @property {number} linksCount - num of links
 * @property {string} origin - origin
 * @property {GUID} uouSessionId - uou_session_id
 * @property {number} screenWidth - screen_width
 * @property {string} environment - environment
 * @property {string} dialogName - dialog_name
 * @property {number} screenHeight - screen_height
 * @property {string} uouReferrer - uou_referrer
 * @property {string} pageName - page_name
 * @property {string} type - type
 * @property {number} windowWidth - window_width
 * @property {string} liniksIds - array of link ids
 * @return {LogObject<uLinksDisconnectedFromPageParams>} LogObject<uLinksDisconnectedFromPageParams>
 */
export function uLinksDisconnectedFromPage(params) {
    return { evid: 57, src: 146, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uPageCreatedSrc146Evid58' event (evid: 58)
 *
 * Event description: User Page Created
 *
 * @param {uPageCreatedSrc146Evid58Params} params - The parameters for this event
 * @property {number} uouIndexInClient - uou_index_in_client
 * @property {GUID} hypeUserId - hype_user_id
 * @property {string} screenPart - screen_part
 * @property {string} hoppUserProfiles - hopp_user_profiles
 * @property {GUID} uouClientId - uou_client_id
 * @property {string} pageId - page id
 * @property {number} windowHeight - window_height
 * @property {string} panelName - panel_name
 * @property {number} uouIndexInSession - uou_index_in_session
 * @property {string} origin - origin
 * @property {GUID} uouSessionId - uou_session_id
 * @property {number} screenWidth - screen_width
 * @property {string} environment - environment
 * @property {string} dialogName - dialog_name
 * @property {number} screenHeight - screen_height
 * @property {string} pageType - page type
 * @property {string} uouReferrer - uou_referrer
 * @property {string} pageName - page_name
 * @property {string} type - type
 * @property {number} windowWidth - window_width
 * @return {LogObject<uPageCreatedSrc146Evid58Params>} LogObject<uPageCreatedSrc146Evid58Params>
 */
export function uPageCreatedSrc146Evid58(params) {
    return { evid: 58, src: 146, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uPagePublished' event (evid: 59)
 *
 * Event description: User Page Published
 *
 * @param {uPagePublishedParams} params - The parameters for this event
 * @property {number} uouIndexInClient - uou_index_in_client
 * @property {GUID} hypeUserId - hype_user_id
 * @property {string} screenPart - screen_part
 * @property {string} hoppUserProfiles - hopp_user_profiles
 * @property {GUID} uouClientId - uou_client_id
 * @property {string} pageId - page id
 * @property {number} windowHeight - window_height
 * @property {string} panelName - panel_name
 * @property {number} uouIndexInSession - uou_index_in_session
 * @property {string} origin - origin
 * @property {GUID} uouSessionId - uou_session_id
 * @property {number} screenWidth - screen_width
 * @property {string} environment - environment
 * @property {string} dialogName - dialog_name
 * @property {number} screenHeight - screen_height
 * @property {string} uouReferrer - uou_referrer
 * @property {string} pageName - page_name
 * @property {string} type - type
 * @property {number} windowWidth - window_width
 * @return {LogObject<uPagePublishedParams>} LogObject<uPagePublishedParams>
 */
export function uPagePublished(params) {
    return { evid: 59, src: 146, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uListItemActionClicked' event (evid: 6)
 *
 * Event description: When user clicks on a button related to a specific item such as a specific contact or link
 *
 * @param {uListItemActionClickedParams} params - The parameters for this event
 * @property {number} uouIndexInClient - uou_index_in_client
 * @property {GUID} hypeUserId - unique hype user id
 * @property {string} screenPart - screen_part
 * @property {string} hoppUserProfiles - hopp_user_profiles
 * @property {GUID} uouClientId - uou_client_id
 * @property {number} windowHeight - window_height
 * @property {string} panelName - panel_name
 * @property {number} uouIndexInSession - uou_index_in_session
 * @property {string} origin - current screen/tab/specific description of location
 * @property {GUID} uouSessionId - uou_session_id
 * @property {number} screenWidth - screen_width
 * @property {string} itemType - the type of the item (contact/list/link..)
 * @property {string} environment - environment
 * @property {string} dialogName - dialog_name
 * @property {string} buttonName - the name of the button
 * @property {number} screenHeight - screen_height
 * @property {string} itemName - any id for the specific item (specific link..)
 * @property {string} uouReferrer - uou_referrer
 * @property {string} pageName - page_name
 * @property {string} type - type
 * @property {number} windowWidth - window_width
 * @return {LogObject<uListItemActionClickedParams>} LogObject<uListItemActionClickedParams>
 */
export function uListItemActionClicked(params) {
    return { evid: 6, src: 146, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uouDestinationRedirectedOnBack' event (evid: 60)
 *
 * Event description: When uou  is redirected on back
 *
 * @param {uouDestinationRedirectedOnBackParams} params - The parameters for this event
 * @property {number} uouIndexInClient - uou_index_in_client
 * @property {GUID} hypeUserId - hype_user_id
 * @property {string} screenPart - screen_part
 * @property {string} linkId - link id
 * @property {string} hoppUserProfiles - hopp_user_profiles
 * @property {GUID} uouClientId - uou_client_id
 * @property {string} pageId - page id
 * @property {number} windowHeight - window_height
 * @property {string} destinationUrl - destination url
 * @property {boolean} afterUserGesture - true\false
 * @property {string} panelName - panel_name
 * @property {number} uouIndexInSession - uou_index_in_session
 * @property {string} origin - origin
 * @property {GUID} uouSessionId - uou_session_id
 * @property {number} screenWidth - screen_width
 * @property {string} environment - environment
 * @property {string} dialogName - dialog_name
 * @property {number} screenHeight - screen_height
 * @property {string} uouReferrer - uou_referrer
 * @property {string} pageName - page_name
 * @property {string} type - type
 * @property {number} windowWidth - window_width
 * @return {LogObject<uouDestinationRedirectedOnBackParams>} LogObject<uouDestinationRedirectedOnBackParams>
 */
export function uouDestinationRedirectedOnBack(params) {
    return { evid: 60, src: 146, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uouEngagementClicked' event (evid: 61)
 *
 * Event description: uou Engagement Clicked
 *
 * @param {uouEngagementClickedParams} params - The parameters for this event
 * @property {number} uouIndexInClient - uou_index_in_client
 * @property {GUID} hypeUserId - hype_user_id
 * @property {string} screenPart - screen_part
 * @property {string} linkId - link id
 * @property {string} actionId - action id
 * @property {string} hoppUserProfiles - hopp_user_profiles
 * @property {GUID} uouClientId - uou_client_id
 * @property {string} pageId - page id
 * @property {string} actionType - action type
 * @property {number} windowHeight - window_height
 * @property {string} destinationUrl - destination url
 * @property {string} panelName - panel_name
 * @property {number} uouIndexInSession - uou_index_in_session
 * @property {string} origin - origin
 * @property {GUID} uouSessionId - uou_session_id
 * @property {number} screenWidth - screen_width
 * @property {string} environment - environment
 * @property {string} actionName - what action is clicked
 * @property {string} dialogName - dialog_name
 * @property {number} screenHeight - screen_height
 * @property {string} pageType - page type
 * @property {string} uouReferrer - uou_referrer
 * @property {string} pageName - page_name
 * @property {string} type - type
 * @property {number} windowWidth - window_width
 * @return {LogObject<uouEngagementClickedParams>} LogObject<uouEngagementClickedParams>
 */
export function uouEngagementClicked(params) {
    return { evid: 61, src: 146, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uPagesDeleted' event (evid: 62)
 *
 * Event description: When user deletes a page
 *
 * @param {uPagesDeletedParams} params - The parameters for this event
 * @property {number} uouIndexInClient - uou_index_in_client
 * @property {GUID} hypeUserId - hype_user_id
 * @property {string} screenPart - screen_part
 * @property {string} hoppUserProfiles - hopp_user_profiles
 * @property {string} pagesIds - pages ids
 * @property {GUID} uouClientId - uou_client_id
 * @property {number} windowHeight - window_height
 * @property {string} panelName - panel_name
 * @property {number} uouIndexInSession - uou_index_in_session
 * @property {string} origin - origin
 * @property {GUID} uouSessionId - uou_session_id
 * @property {number} screenWidth - screen_width
 * @property {string} environment - environment
 * @property {string} dialogName - dialog_name
 * @property {number} screenHeight - screen_height
 * @property {string} pageType - page type
 * @property {string} uouReferrer - uou_referrer
 * @property {string} pageName - page_name
 * @property {string} type - type
 * @property {number} windowWidth - window_width
 * @return {LogObject<uPagesDeletedParams>} LogObject<uPagesDeletedParams>
 */
export function uPagesDeleted(params) {
    return { evid: 62, src: 146, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uouAnyActionClicked' event (evid: 64)
 *
 * Event description: When uou clicks on any action
 *
 * @param {uouAnyActionClickedParams} params - The parameters for this event
 * @property {number} uouIndexInClient - uou_index_in_client
 * @property {GUID} hypeUserId - hype_user_id
 * @property {string} screenPart - screen_part
 * @property {string} linkId - link id
 * @property {string} hoppUserProfiles - hopp_user_profiles
 * @property {GUID} uouClientId - uou_client_id
 * @property {string} pageId - page id
 * @property {number} windowHeight - window_height
 * @property {string} destinationUrl - destination url
 * @property {string} panelName - panel_name
 * @property {number} uouIndexInSession - uou_index_in_session
 * @property {string} origin - origin
 * @property {GUID} uouSessionId - uou_session_id
 * @property {number} screenWidth - screen_width
 * @property {string} environment - environment
 * @property {string} dialogName - dialog_name
 * @property {number} screenHeight - screen_height
 * @property {string} pageType - page type
 * @property {string} uouReferrer - uou_referrer
 * @property {string} pageName - page_name
 * @property {string} type - type
 * @property {number} windowWidth - window_width
 * @property {string} goalSource - goalSource
 * @return {LogObject<uouAnyActionClickedParams>} LogObject<uouAnyActionClickedParams>
 */
export function uouAnyActionClicked(params) {
    return { evid: 64, src: 146, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uApiMethodCalled' event (evid: 65)
 *
 * Event description: when user api method is called
 *
 * @param {uApiMethodCalledParams} params - The parameters for this event
 * @property {string} apiMethodArgs - api method args
 * @property {number} uouIndexInClient - uou_index_in_client
 * @property {GUID} hypeUserId - hype_user_id
 * @property {string} screenPart - screen_part
 * @property {string} apiMethodName - api method name
 * @property {string} hoppUserProfiles - hopp_user_profiles
 * @property {GUID} uouClientId - uou_client_id
 * @property {number} windowHeight - window_height
 * @property {string} panelName - panel_name
 * @property {number} uouIndexInSession - uou_index_in_session
 * @property {string} origin - origin
 * @property {GUID} uouSessionId - uou_session_id
 * @property {number} screenWidth - screen_width
 * @property {string} environment - environment
 * @property {string} dialogName - dialog_name
 * @property {number} screenHeight - screen_height
 * @property {string} uouReferrer - uou_referrer
 * @property {string} pageName - page_name
 * @property {string} type - type
 * @property {number} windowWidth - window_width
 * @return {LogObject<uApiMethodCalledParams>} LogObject<uApiMethodCalledParams>
 */
export function uApiMethodCalled(params) {
    return { evid: 65, src: 146, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uApiMethodCompleted' event (evid: 66)
 *
 * Event description: when user api method is completed
 *
 * @param {uApiMethodCompletedParams} params - The parameters for this event
 * @property {string} apiMethodArgs - api method args
 * @property {number} uouIndexInClient - uou_index_in_client
 * @property {GUID} hypeUserId - hype_user_id
 * @property {string} screenPart - screen_part
 * @property {string} apiMethodName - api method name
 * @property {string} hoppUserProfiles - hopp_user_profiles
 * @property {GUID} uouClientId - uou_client_id
 * @property {number} windowHeight - window_height
 * @property {string} panelName - panel_name
 * @property {number} uouIndexInSession - uou_index_in_session
 * @property {string} origin - origin
 * @property {GUID} uouSessionId - uou_session_id
 * @property {number} screenWidth - screen_width
 * @property {string} environment - environment
 * @property {string} dialogName - dialog_name
 * @property {number} screenHeight - screen_height
 * @property {string} uouReferrer - uou_referrer
 * @property {string} pageName - page_name
 * @property {string} type - type
 * @property {number} windowWidth - window_width
 * @return {LogObject<uApiMethodCompletedParams>} LogObject<uApiMethodCompletedParams>
 */
export function uApiMethodCompleted(params) {
    return { evid: 66, src: 146, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uApiMethodFailed' event (evid: 67)
 *
 * Event description: when user api method failed
 *
 * @param {uApiMethodFailedParams} params - The parameters for this event
 * @property {string} apiMethodArgs - api method args
 * @property {number} uouIndexInClient - uou_index_in_client
 * @property {GUID} hypeUserId - hype_user_id
 * @property {string} screenPart - screen_part
 * @property {string} apiMethodName - api method name
 * @property {string} hoppUserProfiles - hopp_user_profiles
 * @property {GUID} uouClientId - uou_client_id
 * @property {number} windowHeight - window_height
 * @property {string} panelName - panel_name
 * @property {number} uouIndexInSession - uou_index_in_session
 * @property {string} origin - origin
 * @property {GUID} uouSessionId - uou_session_id
 * @property {number} screenWidth - screen_width
 * @property {string} environment - environment
 * @property {string} dialogName - dialog_name
 * @property {number} screenHeight - screen_height
 * @property {string} uouReferrer - uou_referrer
 * @property {string} pageName - page_name
 * @property {string} type - type
 * @property {number} windowWidth - window_width
 * @return {LogObject<uApiMethodFailedParams>} LogObject<uApiMethodFailedParams>
 */
export function uApiMethodFailed(params) {
    return { evid: 67, src: 146, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uFinishedOnboarding' event (evid: 68)
 *
 * Event description: when finished onboarding
 *
 * @param {uFinishedOnboardingParams} params - The parameters for this event
 * @property {number} uouIndexInClient - uou_index_in_client
 * @property {GUID} hypeUserId - hype_user_id
 * @property {string} screenPart - screen_part
 * @property {string} hoppUserProfiles - hopp_user_profiles
 * @property {GUID} uouClientId - uou_client_id
 * @property {number} windowHeight - window_height
 * @property {string} panelName - panel_name
 * @property {number} uouIndexInSession - uou_index_in_session
 * @property {string} origin - origin
 * @property {GUID} uouSessionId - uou_session_id
 * @property {number} screenWidth - screen_width
 * @property {string} environment - environment
 * @property {string} dialogName - dialog_name
 * @property {number} screenHeight - screen_height
 * @property {string} uouReferrer - uou_referrer
 * @property {string} pageName - page_name
 * @property {string} type - type
 * @property {number} windowWidth - window_width
 * @return {LogObject<uFinishedOnboardingParams>} LogObject<uFinishedOnboardingParams>
 */
export function uFinishedOnboarding(params) {
    return { evid: 68, src: 146, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uouSpeedDialLinkRedirected' event (evid: 69)
 *
 * Event description: When uo Speed Dial Link Redirected
 *
 * @param {uouSpeedDialLinkRedirectedParams} params - The parameters for this event
 * @property {number} uouIndexInClient - uou_index_in_client
 * @property {GUID} hypeUserId - hype_user_id
 * @property {string} screenPart - screen_part
 * @property {string} linkId - link id
 * @property {string} hoppUserProfiles - hopp_user_profiles
 * @property {GUID} uouClientId - uou_client_id
 * @property {string} pageId - page id
 * @property {number} windowHeight - window_height
 * @property {string} destinationUrl - destination url
 * @property {string} panelName - panel_name
 * @property {number} uouIndexInSession - uou_index_in_session
 * @property {string} origin - origin
 * @property {GUID} uouSessionId - uou_session_id
 * @property {number} screenWidth - screen_width
 * @property {string} environment - environment
 * @property {string} dialogName - dialog_name
 * @property {number} screenHeight - screen_height
 * @property {string} uouReferrer - uou_referrer
 * @property {string} pageName - page_name
 * @property {string} type - type
 * @property {number} windowWidth - window_width
 * @return {LogObject<uouSpeedDialLinkRedirectedParams>} LogObject<uouSpeedDialLinkRedirectedParams>
 */
export function uouSpeedDialLinkRedirected(params) {
    return { evid: 69, src: 146, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uouCouponCopied' event (evid: 70)
 *
 * Event description: When uou Copied a Coupon
 *
 * @param {uouCouponCopiedParams} params - The parameters for this event
 * @property {number} uouIndexInClient - uou_index_in_client
 * @property {GUID} hypeUserId - hype_user_id
 * @property {string} screenPart - screen_part
 * @property {string} linkId - link id
 * @property {string} actionId - action id
 * @property {string} hoppUserProfiles - hopp_user_profiles
 * @property {GUID} uouClientId - uou_client_id
 * @property {string} pageId - page id
 * @property {number} windowHeight - window_height
 * @property {string} panelName - panel_name
 * @property {number} uouIndexInSession - uou_index_in_session
 * @property {string} origin - origin
 * @property {GUID} uouSessionId - uou_session_id
 * @property {number} screenWidth - screen_width
 * @property {string} environment - environment
 * @property {string} dialogName - dialog_name
 * @property {number} screenHeight - screen_height
 * @property {string} uouReferrer - uou_referrer
 * @property {string} pageName - page_name
 * @property {string} type - type
 * @property {number} windowWidth - window_width
 * @property {string} innerItemId - inner_Item_Id
 * @return {LogObject<uouCouponCopiedParams>} LogObject<uouCouponCopiedParams>
 */
export function uouCouponCopied(params) {
    return { evid: 70, src: 146, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uouSearchBoxClicked' event (evid: 71)
 *
 * Event description: When uou Clicked on Search Box
 *
 * @param {uouSearchBoxClickedParams} params - The parameters for this event
 * @property {number} uouIndexInClient - uou_index_in_client
 * @property {GUID} hypeUserId - hype_user_id
 * @property {string} screenPart - screen_part
 * @property {string} source - source
 * @property {string} hoppUserProfiles - hopp_user_profiles
 * @property {GUID} uouClientId - uou_client_id
 * @property {string} pageId - page id
 * @property {number} windowHeight - window_height
 * @property {string} panelName - panel_name
 * @property {number} uouIndexInSession - uou_index_in_session
 * @property {string} origin - origin
 * @property {GUID} uouSessionId - uou_session_id
 * @property {number} screenWidth - screen_width
 * @property {string} environment - environment
 * @property {string} dialogName - dialog_name
 * @property {number} screenHeight - screen_height
 * @property {string} uouReferrer - uou_referrer
 * @property {string} pageName - page_name
 * @property {string} type - type
 * @property {number} windowWidth - window_width
 * @return {LogObject<uouSearchBoxClickedParams>} LogObject<uouSearchBoxClickedParams>
 */
export function uouSearchBoxClicked(params) {
    return { evid: 71, src: 146, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uouSocialIconClicked' event (evid: 72)
 *
 * Event description: When uou Clicked on Social Icon
 *
 * @param {uouSocialIconClickedParams} params - The parameters for this event
 * @property {number} uouIndexInClient - uou_index_in_client
 * @property {GUID} hypeUserId - hype_user_id
 * @property {string} screenPart - screen_part
 * @property {string} iconType - icon type
 * @property {string} hoppUserProfiles - hopp_user_profiles
 * @property {GUID} uouClientId - uou_client_id
 * @property {string} pageId - page id
 * @property {number} windowHeight - window_height
 * @property {string} panelName - panel_name
 * @property {number} uouIndexInSession - uou_index_in_session
 * @property {string} origin - origin
 * @property {GUID} uouSessionId - uou_session_id
 * @property {number} screenWidth - screen_width
 * @property {string} environment - environment
 * @property {string} dialogName - dialog_name
 * @property {number} screenHeight - screen_height
 * @property {string} uouReferrer - uou_referrer
 * @property {string} pageName - page_name
 * @property {string} type - type
 * @property {number} windowWidth - window_width
 * @property {string} iconUrl - icon url
 * @property {string} linkId - linkId
 * @return {LogObject<uouSocialIconClickedParams>} LogObject<uouSocialIconClickedParams>
 */
export function uouSocialIconClicked(params) {
    return { evid: 72, src: 146, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uOnboardingStarted' event (evid: 73)
 *
 * Event description: when user Onboarding Started
 *
 * @param {uOnboardingStartedParams} params - The parameters for this event
 * @property {number} uouIndexInClient - uou_index_in_client
 * @property {GUID} hypeUserId - hype_user_id
 * @property {string} screenPart - screen_part
 * @property {string} hoppUserProfiles - hopp_user_profiles
 * @property {GUID} uouClientId - uou_client_id
 * @property {number} windowHeight - window_height
 * @property {string} panelName - panel_name
 * @property {number} uouIndexInSession - uou_index_in_session
 * @property {string} origin - origin
 * @property {GUID} uouSessionId - uou_session_id
 * @property {number} screenWidth - screen_width
 * @property {string} initialProduct - Pages/Link in bio/ Preroll / Link shortener
 * @property {string} environment - environment
 * @property {string} dialogName - dialog_name
 * @property {number} screenHeight - screen_height
 * @property {string} uouReferrer - uou_referrer
 * @property {string} pageName - page_name
 * @property {string} type - type
 * @property {number} windowWidth - window_width
 * @property {string} partner - Helps track custom onboarding flows created for specific partners
 * @return {LogObject<uOnboardingStartedParams>} LogObject<uOnboardingStartedParams>
 */
export function uOnboardingStarted(params) {
    return { evid: 73, src: 146, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uSearchLinkAdded' event (evid: 74)
 *
 * Event description: when user added search link
 *
 * @param {uSearchLinkAddedParams} params - The parameters for this event
 * @property {number} uouIndexInClient - uou_index_in_client
 * @property {GUID} hypeUserId - hype_user_id
 * @property {string} screenPart - screen_part
 * @property {string} hoppUserProfiles - hopp_user_profiles
 * @property {string} targetUrl - target Url
 * @property {GUID} uouClientId - uou_client_id
 * @property {string} speedDialCode - speed dial code
 * @property {number} windowHeight - window_height
 * @property {string} panelName - panel_name
 * @property {number} uouIndexInSession - uou_index_in_session
 * @property {string} origin - origin
 * @property {GUID} uouSessionId - uou_session_id
 * @property {number} screenWidth - screen_width
 * @property {string} environment - environment
 * @property {string} dialogName - dialog_name
 * @property {number} screenHeight - screen_height
 * @property {string} uouReferrer - uou_referrer
 * @property {string} pageName - page_name
 * @property {string} title - title
 * @property {string} type - type
 * @property {number} windowWidth - window_width
 * @return {LogObject<uSearchLinkAddedParams>} LogObject<uSearchLinkAddedParams>
 */
export function uSearchLinkAdded(params) {
    return { evid: 74, src: 146, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uouFormSubmitted' event (evid: 75)
 *
 * Event description: When uou Submitted a form
 *
 * @param {uouFormSubmittedParams} params - The parameters for this event
 * @property {number} uouIndexInClient - uou_index_in_client
 * @property {GUID} hypeUserId - hype_user_id
 * @property {string} screenPart - screen_part
 * @property {string} linkId - link id
 * @property {string} actionId - action Id
 * @property {string} hoppUserProfiles - hopp_user_profiles
 * @property {GUID} uouClientId - uou_client_id
 * @property {string} pageId - page id
 * @property {number} windowHeight - window_height
 * @property {string} destinationUrl - destination Url
 * @property {string} panelName - panel_name
 * @property {number} uouIndexInSession - uou_index_in_session
 * @property {string} origin - origin
 * @property {GUID} uouSessionId - uou_session_id
 * @property {number} screenWidth - screen_width
 * @property {string} environment - environment
 * @property {string} dialogName - dialog_name
 * @property {number} screenHeight - screen_height
 * @property {string} uouReferrer - uou_referrer
 * @property {string} pageName - page_name
 * @property {string} type - type
 * @property {number} windowWidth - window_width
 * @return {LogObject<uouFormSubmittedParams>} LogObject<uouFormSubmittedParams>
 */
export function uouFormSubmitted(params) {
    return { evid: 75, src: 146, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uouInputEdited' event (evid: 79)
 *
 * Event description: when a uou enters an input to a text box
 *
 * @param {uouInputEditedParams} params - The parameters for this event
 * @property {number} uouIndexInClient - uou_index_in_client
 * @property {GUID} hypeUserId - hype_user_id
 * @property {string} screenPart - screen_part
 * @property {string} linkId - link id
 * @property {string} inputName - the component's name
 * @property {string} actionId - action id
 * @property {string} hoppUserProfiles - hopp_user_profiles
 * @property {GUID} uouClientId - uou_client_id
 * @property {string} pageId - page id
 * @property {string} actionType - action type
 * @property {number} windowHeight - window_height
 * @property {string} panelName - panel_name
 * @property {number} uouIndexInSession - uou_index_in_session
 * @property {string} origin - origin
 * @property {GUID} uouSessionId - uou_session_id
 * @property {number} screenWidth - screen_width
 * @property {string} environment - environment
 * @property {string} dialogName - dialog_name
 * @property {number} screenHeight - screen_height
 * @property {string} pageType - page type
 * @property {string} uouReferrer - uou_referrer
 * @property {string} pageName - page_name
 * @property {string} type - type
 * @property {number} windowWidth - window_width
 * @property {string} value - value
 * @return {LogObject<uouInputEditedParams>} LogObject<uouInputEditedParams>
 */
export function uouInputEdited(params) {
    return { evid: 79, src: 146, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uouSubmitPaymentIntent' event (evid: 80)
 *
 * Event description: when the uou clicks on 'pay' (doesn't necessarily means that the payment is submitted)
 *
 * @param {uouSubmitPaymentIntentParams} params - The parameters for this event
 * @property {number} uouIndexInClient - uou_index_in_client
 * @property {GUID} hypeUserId - hype_user_id
 * @property {string} screenPart - screen_part
 * @property {string} linkId - link id
 * @property {string} actionId - action id
 * @property {string} hoppUserProfiles - hopp_user_profiles
 * @property {GUID} uouClientId - uou_client_id
 * @property {string} pageId - page id
 * @property {string} actionType - action_type
 * @property {number} windowHeight - window_height
 * @property {string} panelName - panel_name
 * @property {number} uouIndexInSession - uou_index_in_session
 * @property {string} origin - origin
 * @property {GUID} uouSessionId - uou_session_id
 * @property {number} screenWidth - screen_width
 * @property {string} invalidFields - comma separated (null if empty)
 * @property {string} environment - environment
 * @property {string} actionName - action name
 * @property {string} currency - currency
 * @property {string} dialogName - dialog_name
 * @property {number} screenHeight - screen_height
 * @property {string} pageType - page type
 * @property {string} uouReferrer - uou_referrer
 * @property {string} pageName - page_name
 * @property {string} type - type
 * @property {boolean} isCustomAmount - is custom amount
 * @property {number} windowWidth - window_width
 * @property {string} value - value
 * @return {LogObject<uouSubmitPaymentIntentParams>} LogObject<uouSubmitPaymentIntentParams>
 */
export function uouSubmitPaymentIntent(params) {
    return { evid: 80, src: 146, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uouPaymentConfirmation' event (evid: 81)
 *
 * Event description: when the payment confirmation returns for the uou (success/failure)
 *
 * @param {uouPaymentConfirmationParams} params - The parameters for this event
 * @property {number} uouIndexInClient - uou_index_in_client
 * @property {GUID} hypeUserId - hype_user_id
 * @property {string} screenPart - screen_part
 * @property {string} hoppUserProfiles - hopp_user_profiles
 * @property {GUID} uouClientId - uou_client_id
 * @property {string} reason - reason for failure (null otherwise)
 * @property {string} pageId - page id
 * @property {string} actionType - action type
 * @property {number} windowHeight - window_height
 * @property {string} panelName - panel_name
 * @property {number} uouIndexInSession - uou_index_in_session
 * @property {string} origin - origin
 * @property {GUID} uouSessionId - uou_session_id
 * @property {number} screenWidth - screen_width
 * @property {string} environment - environment
 * @property {string} currency - currency
 * @property {string} dialogName - dialog_name
 * @property {number} screenHeight - screen_height
 * @property {string} uouReferrer - uou_referrer
 * @property {string} pageName - page_name
 * @property {string} type - null (success)/failure
 * @property {number} windowWidth - window_width
 * @property {string} value - donation amount
 * @property {string} actionId - action id
 * @return {LogObject<uouPaymentConfirmationParams>} LogObject<uouPaymentConfirmationParams>
 */
export function uouPaymentConfirmation(params) {
    return { evid: 81, src: 146, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uouActionInnerItemGoalAchieved' event (evid: 82)
 *
 * Event description: uou Action Inner Item Goal Achieved
 *
 * @param {uouActionInnerItemGoalAchievedParams} params - The parameters for this event
 * @property {number} uouIndexInClient - uou_index_in_client
 * @property {GUID} hypeUserId - hype_user_id
 * @property {string} screenPart - screen_part
 * @property {string} linkId - link id
 * @property {string} actionId - action id
 * @property {string} hoppUserProfiles - hopp_user_profiles
 * @property {GUID} uouClientId - uou_client_id
 * @property {string} pageId - page id
 * @property {string} innerItemId - inner item id
 * @property {string} actionType - describes the type of action that was clicked
 * @property {number} windowHeight - window_height
 * @property {string} destinationUrl - destination url
 * @property {number} itemPosition - the position of the item
 * @property {string} panelName - panel_name
 * @property {number} uouIndexInSession - uou_index_in_session
 * @property {string} origin - origin
 * @property {GUID} uouSessionId - uou_session_id
 * @property {number} screenWidth - screen_width
 * @property {string} environment - environment
 * @property {string} dialogName - dialog_name
 * @property {number} screenHeight - screen_height
 * @property {string} pageType - page type
 * @property {string} uouReferrer - uou_referrer
 * @property {string} pageName - page_name
 * @property {string} type - type
 * @property {number} windowWidth - window_width
 * @property {number} innerItemPosition - the position of the item
 * @property {string} goalType - Goal type
 * @property {string} goalSource - goal source
 * @return {LogObject<uouActionInnerItemGoalAchievedParams>} LogObject<uouActionInnerItemGoalAchievedParams>
 */
export function uouActionInnerItemGoalAchieved(params) {
    return { evid: 82, src: 146, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uouCreatePaymentIntent' event (evid: 83)
 *
 * Event description: when a uou engages in a payment form
 *
 * @param {uouCreatePaymentIntentParams} params - The parameters for this event
 * @property {number} uouIndexInClient - uou_index_in_client
 * @property {GUID} hypeUserId - hype_user_id
 * @property {string} screenPart - screen_part
 * @property {string} linkId - link_id
 * @property {string} actionId - action id
 * @property {string} hoppUserProfiles - hopp_user_profiles
 * @property {GUID} uouClientId - uou_client_id
 * @property {string} pageId - page_id
 * @property {string} actionType - action_type
 * @property {number} windowHeight - window_height
 * @property {string} note - note
 * @property {string} panelName - panel_name
 * @property {number} uouIndexInSession - uou_index_in_session
 * @property {string} origin - origin
 * @property {GUID} uouSessionId - uou_session_id
 * @property {number} screenWidth - screen_width
 * @property {string} environment - environment
 * @property {string} actionName - action_name
 * @property {string} currency - currency
 * @property {string} dialogName - dialog_name
 * @property {number} screenHeight - screen_height
 * @property {string} pageType - page_type
 * @property {string} uouReferrer - uou_referrer
 * @property {boolean} noteAdded - note_added
 * @property {string} pageName - page_name
 * @property {string} type - type
 * @property {boolean} isCustomAmount - is_custom_amount
 * @property {number} windowWidth - window_width
 * @property {string} value - value
 * @property {string} paymentIntentId - payment_intent_id
 * @return {LogObject<uouCreatePaymentIntentParams>} LogObject<uouCreatePaymentIntentParams>
 */
export function uouCreatePaymentIntent(params) {
    return { evid: 83, src: 146, endpoint: '', params };
}
/**
 * A function to create a log object for the 'premiumSuccessDismiss' event (evid: 85)
 *
 * Event description: When the premium purchase successes
 *
 * @param {premiumSuccessDismissParams} params - The parameters for this event
 * @property {number} uouIndexInClient - uou_index_in_client
 * @property {GUID} hypeUserId - hype_user_id
 * @property {string} screenPart - screen_part
 * @property {string} hoppUserProfiles - hopp_user_profiles
 * @property {GUID} uouClientId - uou_client_id
 * @property {number} windowHeight - window_height
 * @property {string} panelName - panel_name
 * @property {number} uouIndexInSession - uou_index_in_session
 * @property {string} origin - origin
 * @property {GUID} uouSessionId - uou_session_id
 * @property {string} cycleName - the cycle the user chose
 * @property {number} screenWidth - screen_width
 * @property {string} environment - environment
 * @property {string} dialogName - dialog_name
 * @property {string} buttonName - done/dismiss
 * @property {number} screenHeight - screen_height
 * @property {string} uouReferrer - uou_referrer
 * @property {string} pageName - page_name
 * @property {string} type - type
 * @property {number} windowWidth - window_width
 * @property {string} inputJson - inputJson
 * @property {string} packageName - elite, ultimate, essential
 * @property {string} packageId - package_id
 * @property {number} sale - discountPercentage
 * @return {LogObject<premiumSuccessDismissParams>} LogObject<premiumSuccessDismissParams>
 */
export function premiumSuccessDismiss(params) {
    return { evid: 85, src: 146, endpoint: '', params };
}
/**
 * A function to create a log object for the 'premiumFlowStarted' event (evid: 86)
 *
 * Event description: when the premium flows started
 *
 * @param {premiumFlowStartedParams} params - The parameters for this event
 * @property {number} uouIndexInClient - uou_index_in_client
 * @property {GUID} hypeUserId - hype_user_id
 * @property {string} screenPart - screen_part
 * @property {string} triggerFeature - trigger feature
 * @property {string} hoppUserProfiles - hopp_user_profiles
 * @property {string} contextType - context type
 * @property {GUID} uouClientId - uou_client_id
 * @property {string} violatedFeatures - violated feature
 * @property {number} windowHeight - window_height
 * @property {string} panelName - panel_name
 * @property {number} uouIndexInSession - uou_index_in_session
 * @property {string} origin - origin
 * @property {GUID} uouSessionId - uou_session_id
 * @property {number} screenWidth - screen_width
 * @property {string} environment - environment
 * @property {string} dialogName - dialog_name
 * @property {string} buttonName - button name
 * @property {number} screenHeight - screen_height
 * @property {string} uouReferrer - uou_referrer
 * @property {string} pageName - page_name
 * @property {string} type - type
 * @property {number} windowWidth - window_width
 * @property {string} inputJson - json of all fields and the chosen values
 * @return {LogObject<premiumFlowStartedParams>} LogObject<premiumFlowStartedParams>
 */
export function premiumFlowStarted(params) {
    return { evid: 86, src: 146, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uouViewedInnerItemGoalAchieved' event (evid: 87)
 *
 * Event description: This event is sent when uou viewed Inner Item Goal Achieved
 *
 * @param {uouViewedInnerItemGoalAchievedParams} params - The parameters for this event
 * @property {number} uouIndexInClient - uou_index_in_client
 * @property {GUID} hypeUserId - hype_user_id
 * @property {string} screenPart - screen_part
 * @property {string} linkId - link id
 * @property {string} actionId - action id of the list
 * @property {string} hoppUserProfiles - hopp_user_profiles
 * @property {GUID} uouClientId - uou_client_id
 * @property {string} pageId - page id
 * @property {string} innerItemId - inner item id
 * @property {string} actionType - describes the type of action that was clicked
 * @property {number} windowHeight - window_height
 * @property {string} destinationUrl - destination url
 * @property {number} itemPosition - the position of the item
 * @property {string} panelName - panel_name
 * @property {number} uouIndexInSession - uou_index_in_session
 * @property {string} origin - origin
 * @property {GUID} uouSessionId - uou_session_id
 * @property {number} screenWidth - screen_width
 * @property {string} environment - environment
 * @property {string} dialogName - dialog_name
 * @property {number} screenHeight - screen_height
 * @property {string} pageType - page type
 * @property {string} uouReferrer - uou_referrer
 * @property {string} pageName - page_name
 * @property {string} type - type
 * @property {number} windowWidth - window_width
 * @property {number} innerItemPosition - the position of the item
 * @property {string} viewSource - viewSource
 * @return {LogObject<uouViewedInnerItemGoalAchievedParams>} LogObject<uouViewedInnerItemGoalAchievedParams>
 */
export function uouViewedInnerItemGoalAchieved(params) {
    return { evid: 87, src: 146, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uouLockActionViewedSrc146Evid88' event (evid: 88)
 *
 * Event description: When uou views lock actions
 *
 * @param {uouLockActionViewedSrc146Evid88Params} params - The parameters for this event
 * @property {number} uouIndexInClient - uou_index_in_client
 * @property {GUID} hypeUserId - hype_user_id
 * @property {string} screenPart - screen_part
 * @property {string} linkId - link id
 * @property {string} actionId - action id
 * @property {string} hoppUserProfiles - hopp_user_profiles
 * @property {GUID} uouClientId - uou_client_id
 * @property {string} pageId - page id
 * @property {string} actionType - type of the action
 * @property {number} windowHeight - window_height
 * @property {string} destinationUrl - destination url
 * @property {number} itemPosition - position of the item
 * @property {string} panelName - panel_name
 * @property {number} uouIndexInSession - uou_index_in_session
 * @property {string} origin - origin
 * @property {GUID} uouSessionId - uou_session_id
 * @property {number} screenWidth - screen_width
 * @property {string} environment - environment
 * @property {string} dialogName - dialog_name
 * @property {number} screenHeight - screen_height
 * @property {string} pageType - page type
 * @property {string} uouReferrer - uou_referrer
 * @property {string} pageName - page_name
 * @property {string} type - type
 * @property {number} windowWidth - window_width
 * @property {string} lockedActionId - Locked Action Id
 * @property {string} lockSource - lockSource
 * @return {LogObject<uouLockActionViewedSrc146Evid88Params>} LogObject<uouLockActionViewedSrc146Evid88Params>
 */
export function uouLockActionViewedSrc146Evid88(params) {
    return { evid: 88, src: 146, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uouLockActionUnlocked' event (evid: 89)
 *
 * Event description: uou Lock Action Locked
 *
 * @param {uouLockActionUnlockedParams} params - The parameters for this event
 * @property {number} uouIndexInClient - uou_index_in_client
 * @property {GUID} hypeUserId - hype_user_id
 * @property {string} screenPart - screen_part
 * @property {string} linkId - link id
 * @property {string} actionId - action id
 * @property {string} hoppUserProfiles - hopp_user_profiles
 * @property {GUID} uouClientId - uou_client_id
 * @property {string} pageId - page id
 * @property {string} innerItemId - inner item id
 * @property {string} actionType - describes the type of action that was clicked
 * @property {number} windowHeight - window_height
 * @property {string} destinationUrl - destination url
 * @property {number} itemPosition - describes the position of the item
 * @property {string} panelName - panel_name
 * @property {number} uouIndexInSession - uou_index_in_session
 * @property {string} origin - origin
 * @property {GUID} uouSessionId - uou_session_id
 * @property {number} screenWidth - screen_width
 * @property {string} environment - environment
 * @property {string} dialogName - dialog_name
 * @property {number} screenHeight - screen_height
 * @property {string} pageType - page type
 * @property {string} uouReferrer - uou_referrer
 * @property {string} pageName - page_name
 * @property {string} type - type
 * @property {number} windowWidth - window_width
 * @property {string} lockedActionId - Locked Action Id
 * @property {string} lockSource - lockSource
 * @return {LogObject<uouLockActionUnlockedParams>} LogObject<uouLockActionUnlockedParams>
 */
export function uouLockActionUnlocked(params) {
    return { evid: 89, src: 146, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uDropdownClicked' event (evid: 9)
 *
 * Event description: When user clicks on dropdown
 *
 * @param {uDropdownClickedParams} params - The parameters for this event
 * @property {number} uouIndexInClient - uou_index_in_client
 * @property {GUID} hypeUserId - the unique id of a hype user
 * @property {string} screenPart - screen_part
 * @property {string} hoppUserProfiles - hopp_user_profiles
 * @property {GUID} uouClientId - uou_client_id
 * @property {number} windowHeight - window_height
 * @property {string} panelName - panel_name
 * @property {number} uouIndexInSession - uou_index_in_session
 * @property {string} origin - current screen/tab/specific description of location
 * @property {GUID} uouSessionId - uou_session_id
 * @property {number} screenWidth - screen_width
 * @property {string} environment - environment
 * @property {string} dropdownName - the name of the dropdown
 * @property {string} dialogName - dialog_name
 * @property {number} screenHeight - screen_height
 * @property {string} uouReferrer - uou_referrer
 * @property {string} pageName - page_name
 * @property {string} type - type
 * @property {number} windowWidth - window_width
 * @return {LogObject<uDropdownClickedParams>} LogObject<uDropdownClickedParams>
 */
export function uDropdownClicked(params) {
    return { evid: 9, src: 146, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uouActionUnlocked' event (evid: 90)
 *
 * Event description: uou Lock Action Unlocked
 *
 * @param {uouActionUnlockedParams} params - The parameters for this event
 * @property {number} uouIndexInClient - uou_index_in_client
 * @property {GUID} hypeUserId - hype_user_id
 * @property {string} screenPart - screen_part
 * @property {string} linkId - link id
 * @property {string} actionId - action id
 * @property {string} hoppUserProfiles - hopp_user_profiles
 * @property {GUID} uouClientId - uou_client_id
 * @property {string} pageId - page id
 * @property {string} innerItemId - inner item id
 * @property {string} actionType - describes the type of action that was clicked
 * @property {number} windowHeight - window_height
 * @property {string} destinationUrl - destination url
 * @property {number} itemPosition - describes the position of the item
 * @property {string} panelName - panel_name
 * @property {number} uouIndexInSession - uou_index_in_session
 * @property {string} origin - origin
 * @property {GUID} uouSessionId - uou_session_id
 * @property {number} screenWidth - screen_width
 * @property {string} environment - environment
 * @property {string} dialogName - dialog_name
 * @property {number} screenHeight - screen_height
 * @property {string} pageType - page type
 * @property {string} uouReferrer - uou_referrer
 * @property {string} pageName - page_name
 * @property {string} type - type
 * @property {number} windowWidth - window_width
 * @property {string} lockSource - lockSource
 * @return {LogObject<uouActionUnlockedParams>} LogObject<uouActionUnlockedParams>
 */
export function uouActionUnlocked(params) {
    return { evid: 90, src: 146, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uouActionStartUnlockingSrc146Evid91' event (evid: 91)
 *
 * Event description: uou Action Start Unlocking
 *
 * @param {uouActionStartUnlockingSrc146Evid91Params} params - The parameters for this event
 * @property {number} uouIndexInClient - uou_index_in_client
 * @property {GUID} hypeUserId - hype_user_id
 * @property {string} screenPart - screen_part
 * @property {string} linkId - link id
 * @property {string} actionId - action id
 * @property {string} hoppUserProfiles - hopp_user_profiles
 * @property {GUID} uouClientId - uou_client_id
 * @property {string} pageId - page id
 * @property {string} innerItemId - inner item id
 * @property {string} actionType - describes the type of action that was clicked
 * @property {number} windowHeight - window_height
 * @property {string} destinationUrl - destination url
 * @property {number} itemPosition - describes the position of the item
 * @property {string} panelName - panel_name
 * @property {number} uouIndexInSession - uou_index_in_session
 * @property {string} origin - origin
 * @property {GUID} uouSessionId - uou_session_id
 * @property {number} screenWidth - screen_width
 * @property {string} environment - environment
 * @property {string} dialogName - dialog_name
 * @property {number} screenHeight - screen_height
 * @property {string} pageType - page type
 * @property {string} uouReferrer - uou_referrer
 * @property {string} pageName - page_name
 * @property {string} type - type
 * @property {number} windowWidth - window_width
 * @property {string} lockSource - lockSource
 * @return {LogObject<uouActionStartUnlockingSrc146Evid91Params>} LogObject<uouActionStartUnlockingSrc146Evid91Params>
 */
export function uouActionStartUnlockingSrc146Evid91(params) {
    return { evid: 91, src: 146, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uouButtonClickSrc146Evid92' event (evid: 92)
 *
 * Event description: Any uou button click
 *
 * @param {uouButtonClickSrc146Evid92Params} params - The parameters for this event
 * @property {GUID} hypeUserId - hype User Id
 * @property {GUID} actionId -
 * @property {GUID} uouClientId - uou Client Id
 * @property {string} pageId - page Id
 * @property {string} innerItemId - inner item id
 * @property {string} actiontype - action Type
 * @property {string} destinationUrl - destination Url
 * @property {string} scope - search , page , lock, campaign
 * @property {string} value - button value
 * @property {string} action - toggle, open, close etc.
 * @return {LogObject<uouButtonClickSrc146Evid92Params>} LogObject<uouButtonClickSrc146Evid92Params>
 */
export function uouButtonClickSrc146Evid92(params) {
    return { evid: 92, src: 146, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uouActionImpressionSrc146Evid93' event (evid: 93)
 *
 * Event description: When action is fully loaded on uou screen (above the fold)
 *
 * @param {uouActionImpressionSrc146Evid93Params} params - The parameters for this event
 * @property {number} uouIndexInClient - uou_index_in_client
 * @property {GUID} hypeUserId - hype_user_id
 * @property {string} screenPart - screen_part
 * @property {string} linkId - link id
 * @property {string} actionId - action id
 * @property {string} hoppUserProfiles - hopp_user_profiles
 * @property {GUID} uouClientId - uou_client_id
 * @property {string} pageId - page id
 * @property {string} actionType - type of the action
 * @property {number} windowHeight - window_height
 * @property {string} destinationUrl - destination url
 * @property {number} itemPosition - position of the item
 * @property {string} panelName - panel_name
 * @property {number} uouIndexInSession - uou_index_in_session
 * @property {string} origin - origin
 * @property {GUID} uouSessionId - uou_session_id
 * @property {number} screenWidth - screen_width
 * @property {string} environment - environment
 * @property {string} dialogName - dialog_name
 * @property {number} screenHeight - screen_height
 * @property {string} pageType - page type
 * @property {string} uouReferrer - uou_referrer
 * @property {string} pageName - page_name
 * @property {string} type - type
 * @property {number} windowWidth - window_width
 * @property {string} sourceType - sourceType
 * @return {LogObject<uouActionImpressionSrc146Evid93Params>} LogObject<uouActionImpressionSrc146Evid93Params>
 */
export function uouActionImpressionSrc146Evid93(params) {
    return { evid: 93, src: 146, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uouActionInnerItemPreviewedSrc146Evid94' event (evid: 94)
 *
 * Event description: uou Action Inner Item Previewed
 *
 * @param {uouActionInnerItemPreviewedSrc146Evid94Params} params - The parameters for this event
 * @property {number} uouIndexInClient - uou_index_in_client
 * @property {GUID} hypeUserId - hype_user_id
 * @property {string} screenPart - screen_part
 * @property {string} linkId - link id
 * @property {string} actionId - action id
 * @property {string} hoppUserProfiles - hopp_user_profiles
 * @property {GUID} uouClientId - uou_client_id
 * @property {string} pageId - page id
 * @property {string} innerItemId - inner item id
 * @property {string} actionType - describes the type of action that was clicked
 * @property {number} windowHeight - window_height
 * @property {string} destinationUrl - destination url
 * @property {number} itemPosition - the position of the item
 * @property {string} panelName - panel_name
 * @property {number} uouIndexInSession - uou_index_in_session
 * @property {string} origin - origin
 * @property {GUID} uouSessionId - uou_session_id
 * @property {number} screenWidth - screen_width
 * @property {string} environment - environment
 * @property {string} dialogName - dialog_name
 * @property {number} screenHeight - screen_height
 * @property {string} pageType - page type
 * @property {string} uouReferrer - uou_referrer
 * @property {string} pageName - page_name
 * @property {string} type - type
 * @property {number} windowWidth - window_width
 * @property {number} innerItemPosition - the position of the item
 * @property {string} sourceType - source type
 * @property {string} previewType - previewType
 * @return {LogObject<uouActionInnerItemPreviewedSrc146Evid94Params>} LogObject<uouActionInnerItemPreviewedSrc146Evid94Params>
 */
export function uouActionInnerItemPreviewedSrc146Evid94(params) {
    return { evid: 94, src: 146, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uouActionCtaButtonClickedSrc146Evid95' event (evid: 95)
 *
 * Event description: When uou clicks on a cta button in action
 *
 * @param {uouActionCtaButtonClickedSrc146Evid95Params} params - The parameters for this event
 * @property {number} uouIndexInClient - uou_index_in_client
 * @property {GUID} hypeUserId - hype_user_id
 * @property {string} screenPart - screen_part
 * @property {string} linkId - link id
 * @property {string} actionId - action id
 * @property {string} hoppUserProfiles - hopp_user_profiles
 * @property {GUID} uouClientId - uou_client_id
 * @property {string} pageId - page id
 * @property {string} innerItemId - inner item id
 * @property {string} actionType - describes the type of action that was clicked
 * @property {number} windowHeight - window_height
 * @property {string} destinationUrl - destination url
 * @property {number} itemPosition - describes the position of the item
 * @property {string} panelName - panel_name
 * @property {number} uouIndexInSession - uou_index_in_session
 * @property {string} origin - origin
 * @property {GUID} uouSessionId - uou_session_id
 * @property {number} screenWidth - screen_width
 * @property {string} environment - environment
 * @property {string} dialogName - dialog_name
 * @property {number} screenHeight - screen_height
 * @property {string} pageType - page type
 * @property {string} uouReferrer - uou_referrer
 * @property {string} pageName - page_name
 * @property {number} windowWidth - window_width
 * @property {string} ctaButtonId - cta button id
 * @property {number} ctaButtonIndex - cta button index in buttons list
 * @property {string} goalType - This is the goal type: link click, submit, payment...
 * @property {string} goalSource - The source of the goal, search, page, etc...
 * @return {LogObject<uouActionCtaButtonClickedSrc146Evid95Params>} LogObject<uouActionCtaButtonClickedSrc146Evid95Params>
 */
export function uouActionCtaButtonClickedSrc146Evid95(params) {
    return { evid: 95, src: 146, endpoint: '', params };
}
/**
 * A function to create a log object for the 'uouActionCtaButtonViewedSrc146Evid96' event (evid: 96)
 *
 * Event description: When uou view a cta button in action
 *
 * @param {uouActionCtaButtonViewedSrc146Evid96Params} params - The parameters for this event
 * @property {number} uouIndexInClient - uou_index_in_client
 * @property {GUID} hypeUserId - hype_user_id
 * @property {string} screenPart - screen_part
 * @property {string} linkId - link id
 * @property {string} actionId - action id
 * @property {string} hoppUserProfiles - hopp_user_profiles
 * @property {GUID} uouClientId - uou_client_id
 * @property {string} pageId - page id
 * @property {string} innerItemId - inner item id
 * @property {string} actionType - describes the type of action that was clicked
 * @property {number} windowHeight - window_height
 * @property {string} destinationUrl - destination url
 * @property {number} itemPosition - describes the position of the item
 * @property {string} panelName - panel_name
 * @property {number} uouIndexInSession - uou_index_in_session
 * @property {string} origin - origin
 * @property {GUID} uouSessionId - uou_session_id
 * @property {number} screenWidth - screen_width
 * @property {string} environment - environment
 * @property {string} dialogName - dialog_name
 * @property {number} screenHeight - screen_height
 * @property {string} pageType - page type
 * @property {string} uouReferrer - uou_referrer
 * @property {string} pageName - page_name
 * @property {number} windowWidth - window_width
 * @property {string} ctaButtonId - cta button id
 * @property {number} ctaButtonIndex - cta button index in buttons list
 * @property {string} goalType - This is the goal type: link click, submit, payment...
 * @property {string} goalSource - The source of the goal, search, page, etc...
 * @return {LogObject<uouActionCtaButtonViewedSrc146Evid96Params>} LogObject<uouActionCtaButtonViewedSrc146Evid96Params>
 */
export function uouActionCtaButtonViewedSrc146Evid96(params) {
    return { evid: 96, src: 146, endpoint: '', params };
}
//# sourceMappingURL=index.js.map